var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminillustration1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 178,
    viewBox: "0 0 306 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_10957)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306,
    height: 178,
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.353 168.458H77.036C56.5787 170.94 43.9528 174.344 43.9528 178.101C43.9528 185.696 95.5482 191.854 159.194 191.854C222.84 191.854 274.435 185.696 274.435 178.101C274.436 174.344 261.81 170.94 241.353 168.458Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.506 168.747C278.485 165.436 277.495 161.324 275.87 158.105C273.727 153.857 270.64 149.915 270.128 145.116C269.154 135.999 277.782 128.289 277.425 119.121C276.998 108.191 264.227 101.156 264.18 90.2173C264.137 79.9722 275.487 72.0684 273.905 61.965C272.488 52.9126 262.18 49.6225 255.933 43.3503C249.794 37.1882 248.685 26.5506 242.205 20.7766C237.074 16.2058 231.378 12.8867 224.526 12.7C220.022 12.5769 216.259 14.0452 211.996 15.1942C201.015 18.1537 189.783 10.0424 179.308 7.73403C171.158 5.93777 162.386 6.06991 154.271 8.06807C148.406 9.5121 142.746 11.7273 136.929 13.3572C131.015 15.0131 126.235 15.0239 120.274 13.6431C106.349 10.4176 84.9502 19.7087 75.1493 28.5903C64.2838 38.4368 63.7983 51.1432 58.668 65.3989C53.7026 79.1954 52.4305 94.3553 46.7313 107.822C43.5889 115.246 39.1589 122.004 36.3142 129.566C31.647 141.972 31.5939 156.292 36.1411 168.747H277.506Z",
    fill: "#E7EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.495 181.965C214.762 181.966 215.665 180.609 215.188 179.364C213.811 175.77 209.923 173.306 206.225 172.128C199.715 170.056 192.806 170.092 186.016 169.769C179.227 169.445 172.234 168.678 166.27 165.22C164.33 164.096 162.524 162.619 160.986 160.895V117.549H151.086V160.895C149.548 162.619 147.742 164.096 145.802 165.22C139.838 168.678 132.845 169.445 126.056 169.769C119.266 170.092 112.357 170.057 105.847 172.128C102.149 173.306 98.261 175.77 96.8844 179.364C96.4074 180.609 97.3103 181.966 98.5771 181.965C99.4726 181.964 100.368 181.964 101.264 181.963L101.12 181.937C101.231 180.771 102.103 179.812 103.106 179.319C104.109 178.826 105.235 178.022 106.336 177.919C111.75 177.411 200.322 177.411 205.736 177.919C206.837 178.022 207.963 178.826 208.966 179.319C209.969 179.811 210.841 180.771 210.952 181.937L210.809 181.963L213.495 181.965Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.418 165H156.361C154.798 165 153.531 163.656 153.531 161.998V149.373C153.531 147.715 154.798 146.37 156.361 146.37H156.418C157.981 146.37 159.248 147.715 159.248 149.373V161.998C159.248 163.656 157.981 165 156.418 165Z",
    fill: "url(#paint0_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.113 159.768C189.63 148.765 119.493 148.765 50.0094 159.768C48.1603 160.061 46.4974 158.548 46.4974 156.565V22.3695C46.4974 20.3861 48.1607 18.8736 50.0094 19.1665C119.493 30.1694 189.63 30.1698 259.113 19.1665C260.962 18.8736 262.625 20.3861 262.625 22.3695V156.565C262.626 158.548 260.962 160.06 259.113 159.768Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.848 158.935C187.682 147.609 117.82 147.61 48.6541 158.935C48.6541 113.425 48.6541 67.915 48.6541 22.405C117.82 33.7307 187.682 33.7311 256.848 22.405C256.848 67.9146 256.848 113.425 256.848 158.935Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.021 28.3817H199.813V59.1426H249.021V28.3817Z",
    fill: "#B0BABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4644 21.2023C50.4644 66.7123 50.4644 112.222 50.4644 157.732C55.981 156.829 61.5026 156.005 67.0278 155.246L99.2951 27.2994C82.9918 25.8892 66.7089 23.862 50.4644 21.2023Z",
    fill: "#E7EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4893 119.566C79.788 120.031 73.6482 119.1 68.3856 116.774C60.4289 113.104 55.7461 105.67 50.4639 99.0398C50.4639 118.604 50.4639 138.168 50.4639 157.732C119.63 146.407 189.492 146.406 258.658 157.732C258.658 121.465 258.658 85.1974 258.658 48.9304C208.615 71.5986 158.798 92.1784 107.855 113.052C100.4 116.308 93.3835 119.1 85.4893 119.566Z",
    fill: "#B0BABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.754 29.0316H110.353V121.418H197.754V29.0316Z",
    fill: "#848C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.608 48.2758H50.2319V99.0727H108.608V48.2758Z",
    fill: "#B0BABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.618 66.9407H200.017V120.014H258.618V66.9407Z",
    fill: "#848C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.479 62.5173H203.001V116.799H280.479V62.5173Z",
    fill: "url(#paint1_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.075 68.9229C214.177 68.9229 210.207 73.1354 210.207 78.3318C210.207 83.5282 214.177 87.7407 219.075 87.7407C223.973 87.7407 227.944 83.5282 227.944 78.3318C227.944 73.1354 223.973 68.9229 219.075 68.9229ZM219.075 84.0286C216.11 84.0286 213.705 81.478 213.705 78.3313C213.705 75.1851 216.109 72.6341 219.075 72.6341C222.041 72.6341 224.445 75.1846 224.445 78.3313C224.445 81.478 222.041 84.0286 219.075 84.0286Z",
    fill: "url(#paint2_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.076 84.0285C216.164 84.0285 213.796 81.5703 213.71 78.5042H210.211C210.298 83.6204 214.232 87.7402 219.076 87.7402C223.919 87.7402 227.853 83.6204 227.94 78.5042H224.441C224.355 81.5703 221.987 84.0285 219.076 84.0285Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.4 70.1173L221.869 73.465C223.414 74.4654 224.445 76.2703 224.445 78.3313C224.445 78.3894 224.443 78.4466 224.441 78.5038H227.94C227.941 78.4461 227.944 78.3889 227.944 78.3313C227.944 74.8016 226.11 71.7273 223.4 70.1173Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.067 68.9229C235.169 68.9229 231.198 73.1354 231.198 78.3318C231.198 83.5282 235.169 87.7407 240.067 87.7407C244.965 87.7407 248.935 83.5282 248.935 78.3318C248.935 73.1354 244.965 68.9229 240.067 68.9229ZM240.067 84.0286C237.101 84.0286 234.697 81.478 234.697 78.3313C234.697 75.1851 237.101 72.6341 240.067 72.6341C243.032 72.6341 245.437 75.1846 245.437 78.3313C245.437 81.478 243.033 84.0286 240.067 84.0286Z",
    fill: "url(#paint3_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.067 72.6345C241.646 72.6345 243.064 73.3602 244.047 74.5122L246.632 72.0115C245.011 70.1152 242.671 68.9229 240.067 68.9229C238.31 68.9229 236.673 69.467 235.295 70.4028L237.461 73.3554C238.233 72.8988 239.12 72.6345 240.067 72.6345Z",
    fill: "url(#paint4_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.927 77.986C248.849 75.6884 247.993 73.6023 246.632 72.011L244.047 74.5117C244.841 75.4428 245.351 76.6515 245.426 77.986H248.927Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.461 73.3551L235.295 70.4025C232.919 72.0163 231.316 74.7982 231.207 77.9861C231.203 78.1009 231.199 78.2157 231.199 78.3314C231.199 80.7814 232.082 83.0127 233.529 84.6868L236.114 82.186C235.235 81.1718 234.698 79.8183 234.698 78.3314C234.698 78.2153 234.702 78.1005 234.708 77.9861C234.821 75.9905 235.904 74.2757 237.461 73.3551Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.935 78.3313C248.935 78.2156 248.931 78.1008 248.927 77.986H245.426C245.433 78.1003 245.437 78.2152 245.437 78.3313C245.437 79.8424 244.881 81.2154 243.976 82.2353L246.14 85.1849C247.86 83.4688 248.935 81.0343 248.935 78.3313Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.058 68.9229C256.16 68.9229 252.19 73.1354 252.19 78.3318C252.19 83.5282 256.16 87.7407 261.058 87.7407C265.956 87.7407 269.927 83.5282 269.927 78.3318C269.927 73.1354 265.956 68.9229 261.058 68.9229ZM261.058 84.0286C258.093 84.0286 255.688 81.478 255.688 78.3313C255.688 75.1851 258.092 72.6341 261.058 72.6341C264.024 72.6341 266.428 75.1846 266.428 78.3313C266.428 81.478 264.024 84.0286 261.058 84.0286Z",
    fill: "url(#paint5_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.428 78.3313C266.428 80.3788 265.409 82.1738 263.881 83.1776L266.32 85.9045C268.508 84.191 269.927 81.4373 269.927 78.3313C269.927 75.5676 268.804 73.082 267.015 71.3607L264.49 73.9498C265.674 74.9948 266.428 76.5697 266.428 78.3313Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.624 105.027H207.684V106.581H217.624V105.027Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.807 108.459H207.684V109.091H212.807V108.459Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.914 108.459H213.643V109.091H216.914V108.459Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.062 110.145V110.567H214.728V110.145H209.438V110.778H217.318V110.145H215.062Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.02 110.145H207.684V110.778H209.02V110.145Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.877 110.145H217.624V110.778H218.877V110.145Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.043 111.832H207.684V112.464H218.043V111.832Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.229 113.518H207.684V114.15H215.229V113.518Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.877 113.518H215.73V114.15H218.877V113.518Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.989 90.7036H215.764V92.272H221.989V90.7036Z",
    fill: "#B0BABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.003 93.5439H215.751V93.9772H222.003V93.5439Z",
    fill: "url(#paint6_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.003 95.3536H215.751V95.7869H222.003V95.3536Z",
    fill: "url(#paint7_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.179 90.7036H236.954V92.272H243.179V90.7036Z",
    fill: "#B0BABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.193 93.5439H236.941V93.9772H243.193V93.5439Z",
    fill: "url(#paint8_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.193 95.3536H236.941V95.7869H243.193V95.3536Z",
    fill: "url(#paint9_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.37 90.7036H258.144V92.272H264.37V90.7036Z",
    fill: "#B0BABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.383 93.5439H258.131V93.9772H264.383V93.5439Z",
    fill: "url(#paint10_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.383 95.3536H258.131V95.7869H264.383V95.3536Z",
    fill: "url(#paint11_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.392 15.5247H112.055V115.714H196.392V15.5247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.153 18.7816H127.674V21.3829H149.153V18.7816Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.844 18.7817H180.425V21.383H189.844V18.7817Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.844 24.8303H180.425V25.6869H189.844V24.8303Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.099 72.4526C121.651 72.4526 118.856 75.4178 118.856 79.0757C118.856 82.7337 121.651 85.6989 125.099 85.6989C128.547 85.6989 131.342 82.7337 131.342 79.0757C131.342 75.4178 128.547 72.4526 125.099 72.4526ZM125.099 83.0859C123.011 83.0859 121.319 81.2905 121.319 79.0757C121.319 76.861 123.011 75.0656 125.099 75.0656C127.187 75.0656 128.879 76.861 128.879 79.0757C128.879 81.2905 127.187 83.0859 125.099 83.0859Z",
    fill: "url(#paint12_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.099 76.4307C123.722 76.4307 122.606 77.6147 122.606 79.0757C122.606 80.5366 123.722 81.7207 125.099 81.7207C126.476 81.7207 127.592 80.5366 127.592 79.0757C127.592 77.6152 126.476 76.4307 125.099 76.4307ZM125.099 81.4061C123.886 81.4061 122.902 80.3629 122.902 79.0752C122.902 77.788 123.886 76.7448 125.099 76.7448C126.312 76.7448 127.296 77.7885 127.296 79.0752C127.296 80.3629 126.312 81.4061 125.099 81.4061Z",
    fill: "url(#paint13_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.939 72.4526C135.492 72.4526 132.697 75.4178 132.697 79.0757C132.697 82.7337 135.492 85.6989 138.939 85.6989C142.387 85.6989 145.182 82.7337 145.182 79.0757C145.182 75.4178 142.387 72.4526 138.939 72.4526ZM138.939 83.0859C136.852 83.0859 135.16 81.2905 135.16 79.0757C135.16 76.861 136.852 75.0656 138.939 75.0656C141.027 75.0656 142.719 76.861 142.719 79.0757C142.719 81.2905 141.027 83.0859 138.939 83.0859Z",
    fill: "url(#paint14_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.939 76.4307C137.562 76.4307 136.446 77.6147 136.446 79.0757C136.446 80.5366 137.562 81.7207 138.939 81.7207C140.316 81.7207 141.432 80.5366 141.432 79.0757C141.432 77.6152 140.316 76.4307 138.939 76.4307ZM138.939 81.4061C137.726 81.4061 136.743 80.3629 136.743 79.0752C136.743 77.788 137.727 76.7448 138.939 76.7448C140.153 76.7448 141.136 77.7885 141.136 79.0752C141.136 80.3629 140.153 81.4061 138.939 81.4061Z",
    fill: "url(#paint15_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.813 99.4746L120.659 99.0734L142.009 89.8495L146.649 92.0244L152.365 83.2775L156.202 85.8367L160.367 79.4922L160.702 79.74L156.315 86.4233L152.478 83.8646L146.792 92.5651L142.003 90.32L120.813 99.4746Z",
    fill: "url(#paint16_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.942 94.5134H127.196V110.409H130.942V94.5134Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.012 96.98H133.266V110.409H137.012V96.98Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.082 94.1023H139.337V110.409H143.082V94.1023Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.153 98.6241H145.407V110.409H149.153V98.6241Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.223 87.5251H151.478V110.409H155.223V87.5251Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.294 85.3324H157.548V110.408H161.294V85.3324Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.506 29.5525H128.627V68.9229H133.506V29.5525Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.595 29.5525H135.715V68.9229H140.595V29.5525Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.684 29.5525H142.804V68.9229H147.684V29.5525Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.772 29.5525H149.893V68.9229H154.772V29.5525Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.861 29.5525H156.981V68.9229H161.861V29.5525Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.949 29.5525H164.07V68.9229H168.949V29.5525Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.038 29.5525H171.158V68.9229H176.038V29.5525Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.126 29.5525H178.247V68.9229H183.126V29.5525Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.215 29.5525H185.335V68.9229H190.215V29.5525Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.743 32.1874H130.13V68.6858H130.743V32.1874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.889 32.1874H137.276V68.6858H137.889V32.1874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.034 32.1874H144.422V68.6858H145.034V32.1874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.18 32.1874H151.568V68.6858H152.18V32.1874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.326 32.1874H158.714V68.6858H159.326V32.1874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.472 32.1874H165.859V68.6858H166.472V32.1874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.618 32.1874H173.005V68.6858H173.618V32.1874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.764 32.1874H180.151V68.6858H180.764V32.1874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.91 32.1874H187.297V68.6858H187.91V32.1874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.56 50.491H129.314V68.6858H131.56V50.491Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.705 50.491H136.459V68.6858H138.705V50.491Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.851 56.3937H143.605V68.6863H145.851V56.3937Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.997 44.101H150.751V68.6858H152.997V44.101Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.997 44.101H150.751V49.2376H152.997V44.101Z",
    fill: "url(#paint17_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.143 40.3104H157.897V68.6858H160.143V40.3104Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.288 50.491H165.043V68.6858H167.288V50.491Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.435 43.0178H172.189V68.6858H174.435V43.0178Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.435 43.0178H172.189V44.7634H174.435V43.0178Z",
    fill: "url(#paint18_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.58 45.834H179.334V68.6863H181.58V45.834Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.726 50.491H186.48V68.6858H188.726V50.491Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.257 67.1259H121.667V68.5361H126.257V67.1259Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.257 61.3029H121.667V62.7131H126.257V61.3029Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.257 55.48H121.667V56.8902H126.257V55.48Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.257 49.6567H121.667V51.067H126.257V49.6567Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.257 43.8339H121.667V45.2441H126.257V43.8339Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.257 38.0109H121.667V39.4211H126.257V38.0109Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.257 32.1876H121.667V33.5979H126.257V32.1876Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.506 27.6899H128.627V28.2441H133.506V27.6899Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.595 27.6898H135.715V28.2439H140.595V27.6898Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.684 27.6898H142.804V28.2439H147.684V27.6898Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.772 27.6898H149.893V28.2439H154.772V27.6898Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.861 27.6898H156.981V28.2439H161.861V27.6898Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.949 27.6898H164.07V28.2439H168.949V27.6898Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.038 27.6898H171.158V28.2439H176.038V27.6898Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.126 27.6898H178.247V28.2439H183.126V27.6898Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.215 27.6898H185.335V28.2439H190.215V27.6898Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.524 44.1599H25V94.9569H104.524V44.1599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6304 74.6896C98.201 74.6896 103.527 69.0386 103.527 62.0677C103.527 55.0968 98.201 49.4458 91.6304 49.4458C85.0599 49.4458 79.7334 55.0968 79.7334 62.0677C79.7334 69.0386 85.0599 74.6896 91.6304 74.6896Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5854 49.4457C88.2698 49.4591 85.2773 50.9113 83.1281 53.2414L91.0427 62.2526L96.605 50.6007C95.0782 49.8529 93.3777 49.4383 91.5854 49.4457Z",
    fill: "url(#paint19_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.853 55.6122C100.625 53.4286 98.7939 51.6718 96.6046 50.6003L91.0422 62.2522L91.157 62.3826L101.853 55.6122Z",
    fill: "url(#paint20_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1281 53.2415C81.0185 55.5286 79.7211 58.6619 79.7334 62.1153C79.7415 64.4674 80.3578 66.6653 81.4203 68.5465L90.9035 62.5438L91.0423 62.2527L83.1281 53.2415Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0423 62.2522L90.9034 62.5433L91.157 62.3826L91.0423 62.2522Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3294 71.6871L91.1575 62.3826L90.904 62.5429L85.8618 73.1055C87.5831 74.1211 89.5657 74.6973 91.6754 74.6891C94.596 74.6774 97.2651 73.5483 99.3294 71.6871Z",
    fill: "url(#paint21_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4202 68.546C82.4954 70.4497 84.0309 72.0258 85.8612 73.1055L90.9033 62.5428L81.4202 68.546Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.853 55.6122L91.1573 62.3826L99.3292 71.6871C101.908 69.3614 103.541 65.8919 103.527 62.02C103.519 59.6774 102.907 57.4882 101.853 55.6122Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6302 70.8778C96.2165 70.8778 99.9344 66.9333 99.9344 62.0676C99.9344 57.2019 96.2165 53.2574 91.6302 53.2574C87.044 53.2574 83.326 57.2019 83.326 62.0676C83.326 66.9333 87.044 70.8778 91.6302 70.8778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6299 69.7028C87.6618 69.7028 84.4332 66.2775 84.4332 62.0676C84.4332 57.8573 87.6618 54.432 91.6299 54.432C95.5984 54.432 98.827 57.8573 98.827 62.0676C98.827 66.2775 95.5984 69.7028 91.6299 69.7028ZM91.6299 54.8653C87.8868 54.8653 84.8416 58.0964 84.8416 62.0676C84.8416 66.0388 87.8868 69.2696 91.6299 69.2696C95.373 69.2696 98.4186 66.0388 98.4186 62.0676C98.4186 58.0964 95.373 54.8653 91.6299 54.8653Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8879 77.4663H91.3555V78.3289H94.8879V77.4663Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5899 79.7665H91.3555V80.6291H96.5899V79.7665Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8641 79.7665H97.2856V80.6291H99.8641V79.7665Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.721 79.7665H100.071V80.6291H101.721V79.7665Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8567 82.067H91.3555V82.9296H93.8567V82.067Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.949 82.067H94.5269V82.9296H100.949V82.067Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.721 84.3676H98.7816V85.2302H101.721V84.3676Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4978 84.3676H91.3555V85.2302H98.4978V84.3676Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8679 86.6681H91.3555V87.5307H95.8679V86.6681Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4978 86.6681H96.5637V87.5307H98.4978V86.6681Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.903 86.6681H98.7816V87.5307H99.903V86.6681Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2092 84.7396H34.1577V85.3288H43.2092V84.7396Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0466 86.3107H34.1578V86.8999H45.0466V86.3107Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0466 87.8816H38.3203V88.4708H45.0466V87.8816Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3292 87.8816H34.1578V88.4708H37.3292V87.8816Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0466 89.4525H34.1578V90.0417H45.0466V89.4525Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0466 91.0236H34.1578V91.6128H45.0466V91.0236Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3626 52.4287H33.9542V80.6706H34.3626V52.4287Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9338 52.4287H41.5254V80.6706H41.9338V52.4287Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5049 52.4287H49.0966V80.6706H49.5049V52.4287Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.076 52.4287H56.6676V80.6706H57.076V52.4287Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6468 52.4287H64.2384V80.6706H64.6468V52.4287Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2179 52.4287H71.8096V80.6706H72.2179V52.4287Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3887 63.6499H32.9266V80.6706H35.3887V63.6499Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0307 69.4862H40.5686V80.6706H43.0307V69.4862Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5409 64.5806H48.0789V80.6711H50.5409V64.5806Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1028 58.446H55.6407V80.6705H58.1028V58.446Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.674 67.8312H63.2119V80.671H65.674V67.8312Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4938 81.2056H28.9689V81.5665H73.4938V81.2056Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6212 58.5808L72.0138 53.7891L69.4064 58.5808H70.783V80.6706H73.2446V58.5808H74.6212Z",
    fill: "url(#paint22_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1484 79.2867C32.1484 79.4687 32.0092 79.6164 31.8377 79.6164H29.2796C29.1081 79.6164 28.9689 79.4687 28.9689 79.2867C28.9689 79.1048 29.1081 78.957 29.2796 78.957H31.8377C32.0092 78.957 32.1484 79.1048 32.1484 79.2867Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1484 74.5803C32.1484 74.7623 32.0092 74.91 31.8377 74.91H29.2796C29.1081 74.91 28.9689 74.7623 28.9689 74.5803C28.9689 74.3983 29.1081 74.2506 29.2796 74.2506H31.8377C32.0092 74.2506 32.1484 74.3983 32.1484 74.5803Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1484 69.8744C32.1484 70.0563 32.0092 70.2041 31.8377 70.2041H29.2796C29.1081 70.2041 28.9689 70.0563 28.9689 69.8744C28.9689 69.6924 29.1081 69.5447 29.2796 69.5447H31.8377C32.0092 69.5447 32.1484 69.692 32.1484 69.8744Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1484 65.168C32.1484 65.3499 32.0092 65.4977 31.8377 65.4977H29.2796C29.1081 65.4977 28.9689 65.3499 28.9689 65.168C28.9689 64.986 29.1081 64.8383 29.2796 64.8383H31.8377C32.0092 64.8383 32.1484 64.986 32.1484 65.168Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1484 60.462C32.1484 60.644 32.0092 60.7917 31.8377 60.7917H29.2796C29.1081 60.7917 28.9689 60.6444 28.9689 60.462C28.9689 60.2801 29.1081 60.1323 29.2796 60.1323H31.8377C32.0092 60.1323 32.1484 60.2796 32.1484 60.462Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1484 55.7556C32.1484 55.9376 32.0092 56.0853 31.8377 56.0853H29.2796C29.1081 56.0853 28.9689 55.938 28.9689 55.7556C28.9689 55.5736 29.1081 55.4259 29.2796 55.4259H31.8377C32.0092 55.4259 32.1484 55.5736 32.1484 55.7556Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1484 51.0496C32.1484 51.2315 32.0092 51.3793 31.8377 51.3793H29.2796C29.1081 51.3793 28.9689 51.232 28.9689 51.0496C28.9689 50.8676 29.1081 50.7198 29.2796 50.7198H31.8377C32.0092 50.7198 32.1484 50.8672 32.1484 51.0496Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.704 21.0261H203.001V55.8487H252.704V21.0261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.076 37.1903H207.807V49.9413H212.076V37.1903Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.453 41.0643H213.183V49.9412H217.453V41.0643Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.83 32.1875H218.56V49.9413H222.83V32.1875Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.207 37.1903H223.937V49.9413H228.207V37.1903Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.584 32.1875H229.314V49.9413H233.584V32.1875Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.96 33.5978H234.69V49.9413H238.96V33.5978Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.337 30.0646H240.067V49.9413H244.337V30.0646Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.076 48.6649H207.807V49.9408H212.076V48.6649Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.453 44.8367H213.183V49.9408H217.453V44.8367Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.83 47.389H218.56V49.9413H222.83V47.389Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.207 44.8367H223.937V49.9408H228.207V44.8367Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.584 41.7693H229.314V49.9408H233.584V41.7693Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.96 44.8367H234.69V49.9408H238.96V44.8367Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.337 37.1902H240.067V49.9412H244.337V37.1902Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.579 22.5919H242.835V23.646H249.579V22.5919Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.311 24.9203H242.835V25.3492H246.311V24.9203Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.097 24.9203H246.878V25.3492H249.097V24.9203Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.841 26.0645V26.3504H247.614V26.0645H244.025V26.4934H249.371V26.0645H247.841Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.742 26.0645H242.835V26.4934H243.742V26.0645Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.429 26.0645H249.579V26.4934H250.429V26.0645Z",
    fill: "#B0C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.283 29.3276H208.664C208.434 29.3276 208.248 29.13 208.248 28.8861V28.877C208.248 28.6331 208.434 28.4355 208.664 28.4355H211.283C211.513 28.4355 211.7 28.6331 211.7 28.877V28.8861C211.7 29.13 211.513 29.3276 211.283 29.3276Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.628 29.3276H214.008C213.779 29.3276 213.592 29.13 213.592 28.8861V28.877C213.592 28.6331 213.779 28.4355 214.008 28.4355H216.628C216.858 28.4355 217.044 28.6331 217.044 28.877V28.8861C217.044 29.13 216.858 29.3276 216.628 29.3276Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.005 29.3276H219.385C219.155 29.3276 218.969 29.13 218.969 28.8861V28.877C218.969 28.6331 219.155 28.4355 219.385 28.4355H222.005C222.234 28.4355 222.421 28.6331 222.421 28.877V28.8861C222.421 29.13 222.234 29.3276 222.005 29.3276Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.382 29.3276H224.762C224.532 29.3276 224.346 29.13 224.346 28.8861V28.877C224.346 28.6331 224.532 28.4355 224.762 28.4355H227.382C227.611 28.4355 227.798 28.6331 227.798 28.877V28.8861C227.798 29.13 227.611 29.3276 227.382 29.3276Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.758 29.3276H230.139C229.909 29.3276 229.722 29.13 229.722 28.8861V28.877C229.722 28.6331 229.909 28.4355 230.139 28.4355H232.758C232.988 28.4355 233.174 28.6331 233.174 28.877V28.8861C233.174 29.13 232.988 29.3276 232.758 29.3276Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.135 29.3276H235.515C235.285 29.3276 235.099 29.13 235.099 28.8861V28.877C235.099 28.6331 235.285 28.4355 235.515 28.4355H238.135C238.365 28.4355 238.551 28.6331 238.551 28.877V28.8861C238.551 29.13 238.365 29.3276 238.135 29.3276Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.415 29.3276H240.796C240.566 29.3276 240.38 29.13 240.38 28.8861V28.877C240.38 28.6331 240.566 28.4355 240.796 28.4355H243.415C243.645 28.4355 243.832 28.6331 243.832 28.877V28.8861C243.832 29.13 243.645 29.3276 243.415 29.3276Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5618 113.804C68.7202 114.267 68.6067 114.813 68.8321 115.244C69.0281 115.619 69.4463 115.815 69.8498 115.834C70.2532 115.854 70.6489 115.724 71.0308 115.584C71.7352 115.325 72.427 115.027 73.102 114.691C73.5912 114.448 74.0931 114.165 74.3945 113.689C74.7192 113.176 74.7588 112.525 74.7984 111.909C74.9764 109.141 75.3652 106.388 75.9598 103.686C76.1068 103.019 76.2673 102.341 76.2183 101.657C76.1697 100.974 75.8708 100.27 75.3044 99.9402C74.9401 99.7284 74.5084 99.6924 74.0935 99.7084C73.5369 99.7297 72.9579 99.8484 72.5242 100.219C71.8908 100.761 71.7177 101.688 71.5094 102.522C71.01 104.521 70.0723 106.394 68.7917 107.952C68.2796 108.575 67.7067 109.159 67.3444 109.89C66.9822 110.622 66.8695 111.563 67.2995 112.252C67.6576 112.827 68.3404 113.156 68.5618 113.804Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6076 113.262C72.5872 113.854 72.4165 114.464 72.0183 114.88C71.5977 115.318 70.9925 115.478 70.4183 115.62C69.9357 115.74 69.4076 115.856 68.9613 115.626C68.4651 115.371 68.2283 114.774 68.0331 114.227C67.8183 113.625 67.6014 113.014 67.543 112.374C67.4846 111.733 67.6026 111.048 67.9939 110.556C68.3218 110.143 68.8159 109.903 69.3198 109.829C70.1872 109.703 71.0954 110.061 71.7084 110.724C72.3222 111.388 72.6399 112.333 72.6076 113.262Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2803 115.642C69.3598 115.997 68.3438 115.617 67.4944 115.078C66.4629 114.423 65.5485 113.527 64.8241 112.462C65.7723 112.026 66.5082 111.03 66.7255 109.889C67.476 110.333 68.3414 110.426 69.1691 110.623C69.9969 110.82 70.8598 111.172 71.3551 111.955C71.7411 112.565 71.8448 113.393 71.6332 114.106C71.4221 114.819 70.9043 115.401 70.2803 115.642Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3554 111.955C70.86 111.171 69.9971 110.819 69.1694 110.622C68.3416 110.426 67.4767 110.333 66.7257 109.888C66.5534 110.792 66.0539 111.599 65.3838 112.115C67.1067 113.379 69.8869 113.162 70.6317 114.743C70.7342 114.924 70.802 115.109 70.8559 115.295C71.2116 114.998 71.4922 114.583 71.6335 114.106C71.8446 113.393 71.7409 112.565 71.3554 111.955Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7496 96.9889L64.042 97.7278L69.1901 118.963L71.8977 118.224L66.7496 96.9889Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2526 108.865C64.2669 108.592 64.2849 108.318 64.3506 108.056C64.5998 107.059 65.5684 104.944 65.6227 103.909C66.5354 105.222 65.9147 106.25 65.9682 106.758C66.4415 106.75 66.9201 106.741 67.3828 106.857C67.5343 106.895 67.7087 106.977 67.7368 107.151C67.7569 107.273 67.6899 107.397 67.6004 107.467C67.5106 107.537 67.4016 107.565 67.2954 107.592C67.4485 107.688 67.6041 107.786 67.7213 107.934C67.8385 108.082 67.9112 108.291 67.8659 108.483C67.8201 108.676 67.6286 108.823 67.4653 108.753C67.6017 108.881 67.7462 109.025 67.7838 109.222C67.8214 109.419 67.6797 109.665 67.5077 109.62C67.685 109.755 67.6838 110.066 67.5792 110.278C67.4747 110.49 67.2978 110.64 67.1574 110.823C66.9046 111.152 66.7751 111.577 66.591 111.962C66.4068 112.345 66.1283 112.718 65.7501 112.788C65.356 112.861 64.9803 112.584 64.679 112.285C64.5405 112.148 64.4054 111.998 64.3233 111.811C64.2187 111.571 64.2106 111.294 64.2077 111.026C64.1996 110.305 64.2147 109.584 64.2526 108.865Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7207 107.934C67.6035 107.786 67.4475 107.687 67.2947 107.592C67.4009 107.565 67.51 107.537 67.5998 107.467C67.6892 107.397 67.7562 107.273 67.7362 107.151C67.708 106.977 67.5336 106.895 67.3821 106.857C66.9987 106.761 66.6042 106.751 66.2109 106.755C66.8276 108.851 66.8852 110.937 65.7474 112.788C65.7483 112.788 65.7487 112.788 65.7495 112.788C66.1272 112.718 66.4061 112.346 66.5899 111.962C66.7741 111.578 66.9035 111.152 67.1563 110.823C67.2968 110.641 67.4736 110.491 67.5782 110.278C67.6827 110.066 67.6839 109.755 67.5067 109.62C67.679 109.665 67.8203 109.419 67.7827 109.222C67.7456 109.025 67.6006 108.882 67.4642 108.753C67.6276 108.823 67.8191 108.677 67.8648 108.484C67.911 108.291 67.8379 108.082 67.7207 107.934Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6385 108.936C67.1688 108.663 66.6375 108.51 66.1022 108.492L66.1087 108.276C66.6759 108.294 67.2391 108.457 67.7365 108.746L67.6385 108.936Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.636 109.726C67.1304 109.508 66.5971 109.386 66.0503 109.363L66.0585 109.147C66.6285 109.171 67.1852 109.298 67.7132 109.525L67.636 109.726Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2771 111.012C67.0512 110.917 66.8781 110.691 66.8356 110.437C66.8274 110.387 66.8213 110.346 66.8119 110.337C66.8058 110.331 66.785 110.327 66.7499 110.324C66.5506 110.31 66.3513 110.318 66.1569 110.354L66.1222 110.141C66.3333 110.102 66.5489 110.09 66.765 110.109C66.8078 110.112 66.8879 110.118 66.9491 110.177C67.0112 110.236 67.0243 110.318 67.0337 110.379C67.0672 110.582 67.1917 110.743 67.3534 110.811L67.2771 111.012Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8959 89.6916C77.7551 89.5846 78.8022 88.9889 79.636 88.7272C79.8692 89.9017 80.4034 92.8907 81.136 94.2936L81.4202 94.7385C79.4053 96.371 77.3382 97.1777 74.9447 97.8705C77.7085 96.2307 76.7787 92.5372 76.8959 89.6916Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2252 88.8745C78.4751 89.1665 77.6195 89.6015 76.8959 89.6916C76.7787 92.5372 77.7085 96.2307 74.9447 97.8701C75.9346 97.5833 76.8669 97.2731 77.7649 96.897C78.8018 94.4379 79.322 91.7049 79.2252 88.8745Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2436 88.8176C78.4591 89.1062 77.5362 89.5953 76.7632 89.6915C76.8179 90.9098 76.9723 92.2862 76.9392 93.5994C78.8042 93.1857 79.1007 90.8851 79.2436 88.8176Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1221 95.2493C75.6202 95.5141 75.1187 95.829 74.7945 96.3143C74.2546 97.1227 74.3208 98.2093 74.0374 99.1534C75.14 97.9554 76.5533 97.1171 78.0361 96.5443C79.5189 95.9716 81.0772 95.6527 82.6348 95.3819C82.7193 94.9716 82.4722 94.5466 82.1341 94.3282C81.796 94.1099 81.3872 94.0588 80.9915 94.0423C79.3086 93.9734 77.6302 94.4535 76.1221 95.2493Z",
    fill: "url(#paint23_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7973 84.886C78.9859 83.8596 77.8984 83.205 76.706 82.9714L75.9231 82.9532C75.4359 83.549 75.1513 83.588 74.7695 84.279L74.6515 84.8171C74.5616 85.165 74.3628 85.5909 74.0071 85.7481C73.5734 85.9401 73.1809 86.2395 72.7999 86.5449C72.6566 86.6601 72.5014 86.8139 72.51 87.0145C72.5165 87.1679 72.619 87.291 72.7162 87.3971C72.9331 87.6337 73.1568 87.8615 73.3855 88.0834C73.3067 88.868 73.4235 89.6816 73.4554 90.4801C73.4733 90.9272 73.4745 91.4138 73.7188 91.7634C73.9466 92.0896 74.3305 92.2097 74.6915 92.2703C76.1285 92.5125 77.6305 92.1013 78.8532 91.2054C79.6593 90.6149 80.3711 89.7791 80.6533 88.7324C81.0102 87.4097 80.6092 85.9124 79.7973 84.886Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7974 84.8859C78.986 83.8595 77.8985 83.2048 76.7061 82.9713L75.9232 82.9531C75.4361 83.5488 75.1514 83.5878 74.7696 84.2789L74.7075 84.5613C74.8476 86.9429 77.1969 89.4593 77.7944 91.8235C78.1631 91.6545 78.5192 91.4496 78.8533 91.2048C79.6594 90.6143 80.3712 89.7786 80.6534 88.7318C81.0103 87.4095 80.6093 85.9122 79.7974 84.8859Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6515 84.8171C74.6846 84.6893 74.7038 84.5714 74.7091 84.4822L74.6515 84.8171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9633 82.7761C84.6628 82.1734 84.3349 81.586 83.9808 81.0167C83.8166 80.7524 83.6137 80.4695 83.3188 80.4214C83.0318 80.3746 82.7639 80.5687 82.5307 80.7524C82.2889 80.943 82.0472 81.1341 81.8058 81.3247C81.4444 81.1154 81.0263 80.8676 80.6877 80.7377C79.5222 80.2901 78.215 80.3456 77.0814 80.8897L75.9943 80.5206C75.3144 80.9941 75.0012 81.9434 74.9117 82.848C74.757 84.4086 75.138 86.0133 75.8845 87.3313C76.6314 88.6492 77.9623 90.2943 79.1959 90.9832C79.8755 91.3627 80.4688 91.156 81.1586 90.8835C81.2202 90.8593 81.2774 90.8229 81.3374 90.7943C81.6821 90.6691 82.0117 90.4867 82.3126 90.267C83.2376 89.5924 83.9555 88.6458 84.5864 87.6606C85.1308 86.8101 85.6376 85.8552 85.6029 84.8275C85.5784 84.1018 85.2839 83.4186 84.9633 82.7761Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1116 84.0377C76.1205 84.6096 76.2737 85.1784 76.5506 85.6693C76.5881 85.266 76.6257 84.8626 76.6633 84.4592C76.9067 84.714 77.2056 84.909 77.5298 85.0246C77.5845 84.7668 77.6389 84.5091 77.6936 84.2513C77.81 84.4839 78.0125 84.6668 78.2477 84.7512C78.3192 84.587 78.3907 84.4228 78.4617 84.2586C78.5271 84.4098 78.6961 84.5017 78.8501 84.4692C78.8877 84.3219 78.9256 84.175 78.9632 84.0277C78.9873 84.2404 79.2148 84.3982 79.4079 84.3362C79.6011 84.2742 79.7081 84.0091 79.6174 83.818C79.7701 83.9268 79.9229 84.036 80.076 84.1447C80.1507 84.0684 80.1458 83.922 80.0658 83.8518C80.6502 84.0247 81.2766 84.0364 81.8663 83.8847C81.3232 83.4693 80.9074 82.8692 80.6963 82.1951C80.7261 82.4555 80.5999 82.728 80.388 82.8623C80.1761 82.9966 79.8894 82.9849 79.6881 82.8337C79.5321 83.0148 79.3761 83.1954 79.2201 83.3765C79.0735 83.1894 78.8223 83.1292 78.5936 83.15C78.3649 83.1707 78.1473 83.2587 77.9247 83.3176C77.2289 83.5022 76.4681 83.3943 75.8425 83.0217C75.577 84.0243 75.686 85.1325 76.1418 86.0549C75.9862 85.3977 75.9756 84.701 76.1116 84.0377Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9646 81.388C82.0393 82.1432 82.1908 82.8901 82.4162 83.611C81.8629 83.3112 81.6023 82.6393 81.3851 82.0214C81.3287 81.8607 81.272 81.6826 81.3304 81.5223C81.4737 81.1276 81.7624 81.7528 81.9646 81.388Z",
    fill: "url(#paint24_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7965 171.992C66.7428 170.842 68.0042 168.866 69.0778 166.831C70.3756 149.755 69.0685 150.858 69.7508 143.449L74.9134 143.452C75.1254 148.101 75.0176 152.315 74.0514 156.718C73.3032 160.127 72.6445 162.748 71.9132 166.831C71.7763 167.594 71.6253 168.699 71.8098 169.465C71.9454 170.029 72.023 170.553 71.7678 170.987C71.1601 171.999 70.5619 171.755 69.4731 172.18C68.2023 172.675 68.4637 173.697 65.893 173.776C65.4021 173.791 64.8819 173.805 64.4441 173.481C64.2901 173.367 64.1439 173.197 64.1019 172.976C64.0092 172.484 64.4559 172.193 64.7965 171.992Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7054 162.776C73.1456 160.696 73.5809 158.862 74.0513 156.718C75.0175 152.315 75.1253 148.101 74.9134 143.452L69.7508 143.449C69.1211 150.283 70.1845 149.876 69.3351 163.17C71.0658 164.221 72.0356 163.535 72.7054 162.776Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9194 171.318C68.4008 171.742 67.8307 172.092 67.2178 172.248C66.6044 172.405 65.9436 172.356 65.3825 172.02C65.3041 171.973 65.2282 171.921 65.1522 171.869C65.2907 171.749 65.4291 171.629 65.5671 171.51C65.6161 171.467 65.6692 171.423 65.7297 171.42C65.7925 171.416 65.8501 171.457 65.9065 171.49C66.1491 171.63 66.4276 171.637 66.6963 171.641C67.4477 171.651 68.2219 171.657 68.9194 171.318Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7966 171.992C64.9886 171.878 65.1686 171.751 65.3479 171.622C65.8478 172.112 66.5612 172.287 67.3073 172.188C68.9767 171.965 70.4538 170.665 71.8369 169.584C71.9537 170.102 72.0047 170.584 71.7679 170.987C71.1602 171.998 70.562 171.755 69.4733 172.179C68.2024 172.675 68.4638 173.697 65.8931 173.775C65.4022 173.79 64.882 173.804 64.4442 173.48C64.2902 173.366 64.1441 173.197 64.102 172.976C64.0093 172.484 64.456 172.193 64.7966 171.992Z",
    fill: "url(#paint25_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4833 126.951C69.5797 129.553 69.2881 132.715 69.1938 135.316C69.0974 137.965 68.8034 140.603 68.7821 143.255C68.7323 149.481 70.1775 155.808 68.9557 161.856C71.125 162.62 73.4972 162.516 75.6142 161.563C76.4052 151.676 77.4126 138.43 78.964 127.737C76.1185 127.928 72.1369 128.208 69.4833 126.951Z",
    fill: "url(#paint26_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.207 129.344C77.7353 129.375 77.253 129.362 76.765 129.318C76.8634 129.881 76.87 130.441 76.6833 131.117C75.2312 135.502 72.5539 141.971 72.5539 145.918C72.5539 151.687 72.5625 156.21 72.4633 162.363C73.5654 162.305 74.5802 162.027 75.6142 161.562C76.4052 151.675 76.656 140.037 78.207 129.344Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6961 173.702C76.7026 173.698 77.7386 172.786 77.7431 172.779C78.4868 171.666 78.7391 170.465 78.5762 169.076C77.6929 161.544 75.3358 152.206 74.2352 144.762H80.6225C81.5642 152.605 82.6309 161.946 81.2098 169.358C81.037 170.258 81.0191 171.188 81.1387 172.099C81.2163 172.691 81.2837 173.285 81.34 173.879C81.3939 174.447 81.4197 175.09 81.1305 175.468C80.8949 175.776 80.0169 175.619 79.3288 175.961C77.5283 176.857 75.493 177.064 74.2136 176.338C73.4528 175.727 75.0806 174.694 76.6961 173.702Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6227 144.761H74.2354C75.2979 151.946 77.5264 160.89 78.4746 168.276C79.8133 168.866 80.9873 168.073 81.5313 167.286C82.4317 160.254 81.4786 151.891 80.6227 144.761Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8886 173.399C80.9306 173.244 80.9416 173.078 80.9208 172.917C80.8016 173.139 80.7052 173.376 80.6354 173.624C80.6909 173.651 80.7583 173.626 80.8024 173.579C80.8461 173.531 80.871 173.465 80.8886 173.399Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4333 175.683C77.1144 175.788 76.7877 175.884 76.4557 175.88C75.8329 175.873 75.2232 175.487 74.8867 174.887C75.0672 174.75 75.2477 174.612 75.4282 174.474C76.1641 175.106 77.1736 175.127 78.0781 174.935C78.9827 174.744 79.8602 174.369 80.7783 174.299C79.6765 174.802 78.5727 175.307 77.4333 175.683Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1681 174.69C75.4017 175.04 75.7749 175.301 76.2895 175.438C77.0213 175.633 78.0687 175.288 78.7544 175.007C79.5867 174.666 80.4618 174.082 81.3406 173.884C81.3937 174.451 81.4186 175.091 81.1303 175.467C80.8947 175.775 80.0167 175.618 79.3286 175.961C77.5281 176.856 75.4927 177.064 74.2133 176.337C73.7065 175.93 74.2632 175.335 75.1681 174.69Z",
    fill: "url(#paint27_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5538 128.199C83.6445 132.53 82.1826 137.089 81.664 141.557C80.748 149.45 84.781 158.558 83.3493 166.351C81.147 167.491 78.7649 168.394 76.2788 166.984C76.7015 162.304 75.3939 156.151 74.6469 151.525C74.2635 149.149 73.6816 146.81 73.4823 144.405C72.9926 138.507 74.8107 132.403 73.3536 126.718C75.9598 126.582 78.5661 126.446 81.1723 126.31L82.5538 128.199Z",
    fill: "url(#paint28_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9137 130.071C80.3911 129.991 80.8815 129.9 81.2928 129.631C81.7044 129.362 82.0233 128.87 81.9637 128.361C77.9531 128.091 73.9515 127.662 69.9711 127.074C69.7518 127.439 69.8098 127.936 70.0226 128.306C70.2354 128.675 70.5776 128.939 70.9279 129.161C72.247 129.998 73.7914 130.373 75.3265 130.453C76.8607 130.532 78.3962 130.328 79.9137 130.071Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6639 141.557C82.1826 137.089 83.6445 132.53 82.5538 128.199L81.1723 126.311C80.6994 126.336 80.2261 126.36 79.7532 126.385C80.741 128.079 81.4891 129.859 81.249 131.64C79.6156 141.605 81.249 150.27 82.4741 159.802C82.8997 162.149 82.9483 164.439 82.7102 166.67C82.9246 166.567 83.1377 166.461 83.3489 166.352C84.781 158.559 80.7484 149.451 81.6639 141.557Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9264 95.5752C84.9559 96.7142 85.2316 98.5083 85.0601 100.135C84.8236 102.371 84.0604 104.52 83.0635 106.463C82.1435 108.256 81.4039 110.39 81.8834 112.981C82.1206 114.265 82.5927 115.47 83.028 116.684C84.14 119.788 84.7117 123.143 84.6999 126.498C84.6978 127.045 84.6643 127.641 84.3446 128.049C83.986 128.506 83.391 128.572 82.8549 128.602C79.0681 128.812 73.7192 129.027 69.3632 127.297C69.5816 121.002 71.9318 115.69 72.1503 109.395C72.2544 106.394 70.8374 104.318 71.9571 101.601C72.958 99.1742 76.2858 96.1661 78.4339 95.0873C80.2188 94.1914 82.5249 94.0246 83.9264 95.5752Z",
    fill: "url(#paint29_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2961 118.576C73.43 115.28 74.4991 112.056 74.3505 108.761C77.3532 107.534 80.142 105.72 82.5358 103.439C81.1723 106.825 79.7789 110.437 80.3155 114.075C80.6578 116.396 81.7591 118.496 82.5942 120.671C83.4298 122.846 83.9847 125.908 83.2399 128.12C79.6156 128.553 76.3156 128.618 73.0282 127.58C73.827 124.686 73.1736 121.588 73.2961 118.576Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8298 111.096C72.9164 110.242 73.067 109.356 73.5489 108.666C73.9859 108.039 74.6478 107.641 75.2935 107.269C77.8801 105.78 80.5341 104.421 83.2428 103.201C81.3614 107.938 78.3489 112.163 74.5645 115.373C74.2366 115.652 73.8323 115.938 73.4289 115.815C72.9115 115.656 72.7693 114.96 72.742 114.389C72.6897 113.291 72.7187 112.189 72.8298 111.096Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3241 127.695C69.8573 124.882 70.5809 122.052 71.2809 119.316C71.5565 118.239 71.8416 117.125 72.049 116.029C72.4039 114.156 72.5501 112.214 72.6914 110.336C72.8176 108.662 72.9478 106.93 73.2259 105.247C73.7249 102.222 74.9844 98.1587 78.1513 95.9768L78.2623 96.1583C75.1571 98.2977 73.9189 102.301 73.4268 105.284C73.1508 106.957 73.0205 108.685 72.8951 110.354C72.7534 112.238 72.6064 114.186 72.2495 116.071C72.0404 117.174 71.755 118.292 71.4781 119.373C70.7843 122.086 70.0664 124.891 70.5254 127.657L70.3241 127.695Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8001 96.0284C81.5836 95.7516 80.303 96.3824 79.2629 97.0461C77.6914 98.0491 76.2111 99.2171 74.6936 100.323C73.1761 101.428 71.4989 102.38 69.7021 102.48C67.167 99.4628 65.5935 98.6985 63.1147 95.814C62.8419 95.3933 62.6455 94.8968 62.4834 94.4033C62.2265 93.6221 62.0248 92.8024 61.6115 92.1144C61.5311 91.9806 61.4343 91.8454 61.2987 91.7969C61.1831 91.7557 61.0582 91.7843 60.9373 91.7782C60.6555 91.7644 60.4097 91.5659 60.1818 91.3753C59.3295 90.6604 58.4769 89.9456 57.6242 89.2307C57.2738 89.9664 57.948 90.3307 59.0759 91.4806C58.8358 91.4524 58.4005 91.88 58.405 92.156C58.4091 92.432 58.494 92.7158 58.4185 92.9779C58.3552 93.1976 58.1828 93.4151 58.2645 93.6265C58.3103 93.7443 58.4238 93.8119 58.4736 93.9272C58.5422 94.087 58.4675 94.2751 58.4601 94.4531C58.4475 94.7503 58.6231 95.0094 58.7893 95.2382C59.0441 95.5891 59.3075 95.9483 59.6558 96.1701C59.9074 96.3304 60.1928 96.4114 60.4456 96.5691C60.9001 96.8525 61.1096 97.1557 61.3608 97.6843C61.4061 97.7844 61.6593 98.332 61.6924 98.41C61.6936 98.4087 64.1736 103.603 66.7839 107.283C67.1367 107.78 67.7072 108.039 68.2928 107.994C72.6089 107.661 76.8384 106.233 80.7575 104.127C81.6735 103.635 82.5841 103.099 83.3502 102.342C84.2319 101.471 84.9739 100.321 84.8898 98.9225C84.8089 97.5652 83.9877 96.2988 82.8001 96.0284Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8002 96.0284C81.5836 95.7515 80.303 96.3824 79.2629 97.0461C77.6915 98.0491 76.2111 99.2171 74.6936 100.323C73.1761 101.428 71.499 102.38 69.7021 102.479C69.3599 102.072 69.0361 101.709 68.7245 101.373C68.5612 101.514 68.3807 101.64 68.1818 101.746C65.3232 103.479 62.4646 99.5793 61.2395 96.5466C60.8446 95.7082 59.3051 95.6775 58.4655 94.4999C58.4724 94.7767 58.6325 95.0215 58.7897 95.2377C59.0445 95.5886 59.3079 95.9478 59.6563 96.1696C59.9078 96.3299 60.1933 96.4109 60.446 96.5686C60.9006 96.852 61.11 97.1553 61.3612 97.6838C61.4065 97.7839 61.6597 98.3315 61.6928 98.4095C61.694 98.4082 64.1736 103.602 66.7843 107.283C67.1376 107.78 67.7077 108.039 68.2933 107.994C72.6093 107.661 76.8388 106.232 80.7579 104.127C81.6739 103.635 82.5845 103.098 83.3506 102.342C84.2323 101.471 84.9743 100.321 84.8902 98.9221C84.8089 97.5651 83.9877 96.2987 82.8002 96.0284Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6225 95.6009C80.5571 95.7331 79.6599 96.4692 78.7815 97.1221C76.6372 98.716 74.2637 99.9629 71.7686 100.806C71.1977 100.999 70.61 101.176 70.1151 101.534C69.6202 101.893 69.2257 102.477 69.249 103.113C69.2702 103.682 69.6173 104.208 69.5789 104.776C69.5373 105.397 69.0599 105.866 68.6813 106.342C68.3028 106.817 67.9944 107.515 68.315 108.037C68.5135 108.359 68.8884 108.496 69.2367 108.606C69.7766 108.777 70.3275 108.941 70.8065 109.255C71.2855 109.57 71.6926 110.063 71.7784 110.654C71.8319 111.024 71.7572 111.4 71.7506 111.775C71.7441 112.15 71.827 112.563 72.1092 112.788C72.2803 112.924 72.5016 112.971 72.7156 112.968C73.7745 112.957 74.5145 111.914 75.223 111.079C77.5838 108.296 81.1991 106.992 83.5509 104.201C84.3513 103.25 84.994 102.124 85.2533 100.88C85.5127 99.6358 85.3595 98.268 84.6935 97.2079C84.027 96.1477 82.8154 95.4528 81.6225 95.6009Z",
    fill: "url(#paint30_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7704 102.125L69.598 102.009C70.0174 101.309 70.7794 100.82 71.862 100.556C72.2034 100.472 72.5546 100.412 72.894 100.355C73.4069 100.268 73.9378 100.177 74.4347 100.003C75.5345 99.6186 76.4897 98.8162 77.2986 98.0948L77.6004 97.8245C78.371 97.1313 79.1681 96.4147 80.0878 95.9269C81.2737 95.2978 82.5164 95.1812 83.4973 95.6071L83.4197 95.8077C82.4935 95.4057 81.3121 95.5196 80.1789 96.1205C79.2813 96.5967 78.4939 97.3046 77.7323 97.9896L77.4301 98.2608C76.6065 98.9956 75.6329 99.8127 74.4985 100.209C73.9855 100.388 73.4469 100.48 72.9258 100.569C72.5897 100.625 72.2422 100.685 71.9073 100.766C70.8791 101.018 70.1603 101.475 69.7704 102.125Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7267 102.968C72.7952 103.474 71.7502 103.743 70.7035 103.747C70.4054 103.747 70.0677 103.743 69.8623 103.972C70.0322 104.525 69.9566 105.156 69.6614 105.646C70.1036 105.056 70.844 104.847 71.5003 104.558C72.3329 104.193 73.0945 103.649 73.7267 102.968Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2963 104.358C76.3015 106.361 74.1702 108.212 71.9254 109.891C71.2246 109.117 70.267 108.611 69.2628 108.482C70.9192 108.377 72.5277 107.82 74.0232 107.057C75.5182 106.294 76.912 105.328 78.2963 104.358Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5731 112.302C74.6978 111.548 75.5603 110.376 76.5534 109.436C77.6095 108.436 78.7966 107.741 80.016 106.978C81.2354 106.216 82.4184 105.188 82.8411 103.755C82.0015 105.222 80.6253 106.25 79.2111 107.084C77.7969 107.917 76.2978 108.605 74.9865 109.611C73.9852 110.378 73.1109 111.318 72.3007 112.308C72.4334 112.515 72.6894 112.602 72.9238 112.578C73.1578 112.554 73.3743 112.436 73.5731 112.302Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2994 87.5112C73.3897 87.5406 73.482 87.574 73.553 87.6398C73.6245 87.7057 73.6707 87.8114 73.6429 87.9072C73.6155 88.0029 73.4963 88.0644 73.4187 88.0068C73.1941 87.8244 72.9924 87.6095 72.8217 87.3704C72.9817 87.4146 73.1414 87.4592 73.2994 87.5112Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.001 109.861C226.959 109.551 226.759 109.278 226.748 108.966C226.741 108.755 226.822 108.55 226.825 108.338C226.831 108.009 226.651 107.713 226.52 107.413C226.361 107.048 226.268 106.651 226.248 106.25C226.025 106.319 225.829 106.479 225.709 106.69C225.589 106.9 225.546 107.159 225.593 107.401C225.643 107.663 225.793 107.918 225.737 108.18C225.717 108.278 225.669 108.364 225.611 108.445C225.599 108.429 225.587 108.414 225.574 108.399C225.376 108.162 225.114 107.999 224.873 107.813C224.077 107.198 223.504 106.321 222.887 105.507C222.786 105.374 222.626 105.229 222.487 105.314C222.353 105.396 222.341 105.721 222.393 105.876C222.655 106.654 223.09 107.269 223.59 107.904C223.656 107.987 223.726 108.074 223.747 108.181C223.774 108.32 223.712 108.459 223.654 108.587C223.518 108.89 223.398 109.2 223.293 109.518C223.193 109.823 223.107 110.154 223.192 110.465C223.249 110.673 223.378 110.85 223.507 111.019C223.803 111.41 224.158 111.82 224.628 111.877C224.863 111.906 225.205 111.987 225.48 111.968C226.314 112.697 227.067 113.529 227.719 114.442C228.226 113.861 228.815 113.363 229.462 112.969C228.598 112.1 227.764 111.198 226.963 110.265C227.006 110.136 227.02 109.996 227.001 109.861Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.501 110.598C223.385 110.293 223.437 109.949 223.49 109.625C223.575 109.108 223.66 108.59 223.746 108.072C223.945 108.269 224.227 108.329 224.488 108.413C224.748 108.497 225.024 108.638 225.124 108.906C225.158 108.996 225.168 109.094 225.178 109.191C225.234 109.721 225.29 110.252 225.346 110.782C225.083 111.049 224.725 111.225 224.361 111.207C223.997 111.189 223.637 110.956 223.501 110.598Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.603 108.893C223.765 109.017 223.931 109.133 224.103 109.24C224.189 109.295 224.292 109.349 224.387 109.314C224.488 109.275 224.535 109.151 224.543 109.037C224.559 108.799 224.454 108.567 224.305 108.389C224.157 108.21 223.967 108.077 223.779 107.946C223.689 107.883 223.593 107.819 223.485 107.818C223.334 107.816 223.2 107.953 223.166 108.11C223.132 108.267 223.183 108.434 223.271 108.565C223.358 108.697 223.481 108.798 223.603 108.893Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.91 109.34C222.971 109.507 223.127 109.608 223.273 109.698C223.444 109.803 223.616 109.908 223.788 110.014C223.909 110.088 224.033 110.164 224.172 110.187C224.31 110.21 224.467 110.171 224.55 110.051C224.621 109.949 224.624 109.807 224.584 109.687C224.545 109.567 224.467 109.466 224.385 109.373C224.087 109.036 223.709 108.78 223.296 108.635C223.224 108.609 223.142 108.588 223.074 108.622C222.995 108.662 222.961 108.761 222.936 108.85C222.892 109.01 222.853 109.185 222.91 109.34Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.961 109.922C222.88 110.102 222.919 110.326 223.027 110.488C223.136 110.651 223.305 110.758 223.483 110.824C223.66 110.889 223.848 110.917 224.033 110.949C224.127 110.965 224.223 110.982 224.318 110.967C224.412 110.952 224.506 110.898 224.548 110.807C224.613 110.665 224.528 110.495 224.421 110.386C224.283 110.244 224.108 110.151 223.936 110.059C223.779 109.976 223.622 109.892 223.465 109.809C223.375 109.761 223.277 109.712 223.178 109.73C223.081 109.748 223.003 109.829 222.961 109.922Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.272 119.437L249.502 118.808C241.688 119.175 233.783 116.189 227.934 110.683C227.704 110.467 227.36 110.457 227.128 110.672C226.767 111.006 226.426 111.363 226.17 111.79C225.818 112.377 225.646 113.128 225.88 113.778C226.071 114.31 226.498 114.699 226.909 115.066C229.651 117.508 232.409 119.958 235.486 121.901C238.562 123.843 241.997 125.271 245.571 125.483C247.274 125.584 249.099 125.363 250.432 124.236C251.766 123.109 252.342 120.846 251.272 119.437Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.066 119.752C243.066 119.917 242.94 120.05 242.785 120.05C242.63 120.05 242.504 119.917 242.504 119.752C242.504 119.588 242.63 119.454 242.785 119.454C242.94 119.454 243.066 119.588 243.066 119.752Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.084 121.865C239.084 121.999 238.981 122.108 238.854 122.108C238.727 122.108 238.624 121.999 238.624 121.865C238.624 121.73 238.727 121.621 238.854 121.621C238.981 121.621 239.084 121.73 239.084 121.865Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.574 118.751C238.771 118.751 238.931 118.581 238.931 118.372C238.931 118.162 238.771 117.992 238.574 117.992C238.376 117.992 238.216 118.162 238.216 118.372C238.216 118.581 238.376 118.751 238.574 118.751Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.03 116.639C234.143 116.639 234.235 116.542 234.235 116.422C234.235 116.302 234.143 116.205 234.03 116.205C233.918 116.205 233.826 116.302 233.826 116.422C233.826 116.542 233.918 116.639 234.03 116.639Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.733 116.178C231.733 116.343 231.608 116.476 231.452 116.476C231.297 116.476 231.172 116.343 231.172 116.178C231.172 116.013 231.297 115.88 231.452 115.88C231.608 115.88 231.733 116.014 231.733 116.178Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.181 112.875C229.181 113.009 229.078 113.118 228.951 113.118C228.824 113.118 228.721 113.009 228.721 112.875C228.721 112.74 228.824 112.631 228.951 112.631C229.078 112.631 229.181 112.74 229.181 112.875Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.599 114.472C227.768 114.472 227.905 114.327 227.905 114.147C227.905 113.968 227.768 113.822 227.599 113.822C227.43 113.822 227.292 113.968 227.292 114.147C227.292 114.327 227.43 114.472 227.599 114.472Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.033 112.047C225.778 112.586 225.678 113.22 225.879 113.778C226.07 114.31 226.497 114.7 226.908 115.066C229.65 117.508 232.409 119.959 235.485 121.901C238.561 123.843 241.996 125.271 245.57 125.483C247.273 125.584 249.098 125.364 250.431 124.236C251.007 123.75 251.44 123.051 251.662 122.302C242.356 123.931 232.154 119.852 226.033 112.047Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.643 117.249C235.388 118.151 235.695 119.202 236.386 119.794C236.388 118.892 236.126 117.991 235.643 117.249Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.893 178.422V178.129L263.908 178.13V177.754C263.908 177.391 263.646 177.089 263.305 177.06C261.523 176.906 256.277 176.447 254.26 176.195C251.812 175.89 250.804 174.515 250.804 174.515H250.486V165.643H250.166V152.917H248.961V165.643H248.641V174.515H248.324C248.324 174.515 247.316 175.89 244.868 176.195C242.85 176.447 237.604 176.907 235.822 177.06C235.482 177.089 235.219 177.391 235.219 177.754V178.13L235.46 178.109V179.244H236.429V178.026L247.796 177.052C247.566 177.261 247.32 177.453 247.073 177.629C246.866 177.777 246.653 177.924 246.503 178.135C246.43 178.238 246.377 178.352 246.338 178.472H245.595V181.45H248.085V178.472H247.303C247.312 178.393 247.317 178.314 247.328 178.236C248.307 178.089 249.236 177.623 249.983 176.936L262.922 178.045V178.429C262.333 178.648 261.907 179.237 261.907 179.937C261.907 180.823 262.584 181.541 263.419 181.541C264.255 181.541 264.932 180.823 264.932 179.937C264.932 179.228 264.494 178.633 263.893 178.422Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.899 156.495C231.13 157.193 230.42 158.237 230.719 159.263C231.103 160.585 232.752 160.809 234.057 160.785C238.871 160.695 243.685 160.607 248.499 160.517C251.67 160.459 255.104 160.303 257.564 158.178C259.315 156.665 260.287 154.374 261.036 152.114C262.109 148.874 262.853 145.501 263.1 142.077C263.267 139.764 263.186 137.34 262.188 135.276C261.19 133.212 259.072 131.615 256.906 131.936C255.397 132.16 254.101 133.262 253.245 134.599C252.389 135.937 251.911 137.501 251.474 139.05C250.409 142.821 249.391 146.883 246.608 149.488C242.543 153.293 236.019 152.757 231.899 156.495Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.899 155.484C231.13 156.182 230.42 157.226 230.719 158.252C231.103 159.575 232.752 159.798 234.057 159.774C238.871 159.685 243.685 159.596 248.499 159.507C251.67 159.448 255.104 159.292 257.564 157.168C259.315 155.655 260.287 153.364 261.036 151.103C262.109 147.863 262.853 144.491 263.1 141.067C263.267 138.753 263.186 136.329 262.188 134.265C261.19 132.201 259.072 130.604 256.906 130.925C255.397 131.149 254.101 132.251 253.245 133.588C252.389 134.926 251.911 136.489 251.474 138.039C250.409 141.81 249.391 145.872 246.608 148.476C242.543 152.282 236.019 151.746 231.899 155.484Z",
    fill: "url(#paint31_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.394 135.178C260.3 135.464 260.889 136.444 261.038 137.434C261.187 138.424 260.978 139.432 260.756 140.406C260.223 142.735 259.604 145.042 258.901 147.319C258.052 150.07 257.01 152.891 254.976 154.82C252.805 156.879 249.813 157.627 246.929 158.053C243.531 158.555 240.091 158.711 236.661 158.602C235.647 158.57 234.466 158.414 233.947 157.489C233.615 156.897 233.668 156.127 233.949 155.507C234.23 154.887 234.71 154.394 235.214 153.962C237.984 151.588 241.638 150.733 244.675 148.761C247.3 147.057 249.429 144.507 250.707 141.538C251.242 140.295 251.631 138.983 252.199 137.755C252.767 136.528 253.546 135.36 254.655 134.665C255.765 133.97 257.253 133.84 258.316 134.613L259.394 135.178Z",
    fill: "url(#paint32_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.71 176.646C224.567 176.238 226 175.797 226.85 174.948C228.14 173.658 228.066 173.053 228.177 171.709C228.306 170.158 227.981 168.205 227.851 166.654C227.808 166.145 227.756 165.636 227.706 165.127H231.858C231.265 168.572 231.278 172.134 231.916 175.571C232.042 176.254 232.17 177.045 231.748 177.578C231.385 178.037 230.739 178.115 230.183 178.009C229.628 177.903 229.256 177.772 228.698 177.87C226.912 178.186 225.098 178.79 223.413 178.305C223.098 178.215 222.511 178.012 222.444 177.673C222.361 177.247 223.336 176.825 223.71 176.646Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.916 175.571C231.279 172.135 231.265 168.573 231.859 165.128H227.707C227.756 165.637 227.808 166.145 227.851 166.655C227.903 167.275 227.986 167.959 228.059 168.656C229.624 169.279 230.026 171.342 230.713 172.799C231.529 174.965 229.488 176.265 227.854 176.698C226.222 177.17 224.321 177.583 222.444 177.65C222.445 177.658 222.444 177.665 222.445 177.673C222.512 178.013 223.099 178.215 223.414 178.306C225.098 178.79 226.912 178.187 228.699 177.87C229.256 177.772 229.628 177.903 230.184 178.009C230.74 178.116 231.386 178.038 231.749 177.579C232.17 177.045 232.043 176.254 231.916 175.571Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.109 178.873C223.528 178.817 222.93 178.688 222.465 178.315C222.26 178.15 222.073 177.896 222.125 177.628C222.163 177.434 222.315 177.291 222.465 177.175C222.883 176.852 223.364 176.62 223.867 176.496C223.858 176.783 224.031 177.051 224.256 177.21C224.481 177.369 224.753 177.436 225.02 177.479C226.218 177.672 227.441 177.449 228.62 177.152C229.799 176.854 230.969 176.481 232.176 176.367C232.319 176.992 232.017 177.702 231.478 178C230.832 178.359 230.052 178.126 229.323 178.126C228.45 178.126 227.615 178.474 226.764 178.681C225.896 178.892 224.996 178.957 224.109 178.873Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.974 168.761C227.959 168.058 227.909 167.354 227.85 166.655C227.807 166.145 227.755 165.637 227.706 165.128H231.858C231.651 166.328 231.523 167.543 231.464 168.761H227.974Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.703 166.95L227.915 167.185C227.332 167.183 226.841 166.726 226.758 166.114C225.938 160.059 224.652 156.107 225.652 150.634C226.006 148.692 227.876 147.009 229.709 146.652C234.554 145.708 241.88 144.984 242.336 139.246L249.483 140.668C249.649 143.298 249.644 149.498 247.303 153.086L231.989 154.223C232.168 159.21 232.269 161.627 232.703 166.95Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.161 147.713C242.856 148.722 236.055 147.963 229.896 150.27C228.671 151.136 227.037 152.436 227.446 154.169C227.94 158.625 228.136 162.922 228.485 167.157L232.703 166.95C232.269 161.627 232.168 159.21 231.989 154.223L247.303 153.086C248.274 151.597 248.839 149.659 249.161 147.713Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.761 181.183C227.521 180.69 228.996 180.003 230.001 179.45C231.078 178.858 231.49 178.226 231.639 177.042C231.833 175.498 231.406 172.735 231.276 171.184C231.233 170.674 231.18 170.165 231.131 169.656H235.283C235.157 173.29 234.703 176.664 235.341 180.1C235.468 180.783 235.595 181.574 235.173 182.108C234.569 182.871 233.421 182.605 232.606 182.588C231.609 182.569 230.611 182.623 229.621 182.75C228.705 182.868 227.751 183.091 226.839 182.835C226.523 182.746 226.191 182.542 226.124 182.202C226.04 181.776 226.41 181.41 226.761 181.183Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.341 180.1C234.703 176.663 235.157 173.289 235.283 169.656H233.821C234.287 174.021 234.834 178.609 234.055 182.63C234.486 182.593 234.889 182.465 235.172 182.107C235.595 181.574 235.467 180.783 235.341 180.1Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.248 173.348C231.234 172.646 231.121 171.836 231.062 171.137C231.019 170.627 231.18 170.164 231.131 169.656L235.585 169.695C235.378 170.895 235.346 172.13 235.287 173.348H231.248Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.216 171.789H231.437C230.768 171.789 230.203 171.264 230.115 170.56L228.687 159.158C228.483 157.532 228.154 155.461 228.897 154.023C229.389 153.072 229.933 152.112 230.773 151.494C234.275 148.92 239.236 148.24 241.981 145.414C243.335 144.022 243.418 142.218 243.959 139.819C246.557 140.399 250.323 141.171 252.41 142.959C253.229 160.336 243.03 153.622 236.403 156.966C236.397 161.55 236.554 166.093 236.374 170.619C236.349 171.274 235.835 171.789 235.216 171.789Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.543 140.958C243.049 140.728 242.449 140.533 241.996 140.844C241.314 141.313 241.496 142.549 240.842 143.06C244.952 144.615 248.557 147.631 250.94 151.509C251.58 150.075 251.337 148.329 250.615 146.939C249.894 145.55 248.748 144.464 247.553 143.51C246.305 142.513 244.974 141.625 243.543 140.958Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.411 142.959C251.823 142.455 251.098 142.034 250.307 141.673C252.662 151.264 242.988 157.105 234.796 155.035C236.021 159.801 236.429 165 233.979 169.333C233.287 170.434 231.788 170.911 230.167 170.801C230.339 171.38 230.847 171.789 231.437 171.789H235.216C235.834 171.789 236.348 171.274 236.375 170.618C236.554 166.092 236.397 161.55 236.404 156.965C243.03 153.622 253.23 160.336 252.411 142.959Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.905 141.821C241.146 141.439 241.186 140.435 241.427 140.053C243.574 140.22 245.483 141.57 247.062 143.124C248.64 144.678 250.003 146.48 251.699 147.887C251.918 148.069 252.151 148.254 252.273 148.52C252.547 149.121 252.15 149.809 251.77 150.342C250.537 148.644 248.97 147.259 247.415 145.889C245.344 144.063 243.424 142.828 240.905 141.821Z",
    fill: "url(#paint33_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.146 132.789C242.632 131.69 242.152 130.584 242.056 129.376C241.916 127.63 242.59 126.001 243.489 124.49C243.468 121.154 245.967 118.396 249.143 118.388C250.713 118.385 252.284 118.545 253.824 118.871C255.277 119.178 256.794 119.691 257.734 120.906C258.452 121.834 258.734 123.053 258.906 124.24C259.753 130.064 253.924 135.993 252.841 148.621C252.81 148.987 252.416 149.186 252.137 148.968C248.802 146.363 244.732 140.735 240.98 140.312C241.906 139.099 242.699 136.23 243.146 132.789Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.906 124.24C258.733 123.053 258.452 121.834 257.734 120.905C256.794 119.69 255.277 119.177 253.824 118.87C253.226 118.744 252.621 118.65 252.015 118.573C250.609 120.479 249.395 122.427 249.753 124.708C249.854 127.074 249.953 129.467 249.922 131.827C248.628 131.739 247.333 131.651 246.039 131.563C245.445 131.523 244.844 131.481 244.277 131.291C243.709 131.101 243.169 130.745 242.862 130.204C242.654 129.835 242.477 129.329 242.072 129.3C242.328 130.809 242.972 132.242 243.916 133.403C243.993 133.497 244.08 133.595 244.196 133.613C244.501 133.66 244.612 133.176 244.884 133.021C245.094 132.9 245.36 133.009 245.548 133.168C245.735 133.326 245.888 133.534 246.101 133.652C246.593 133.925 247.191 133.623 247.745 133.674C248.574 133.751 249.123 134.57 249.781 135.135C249.52 138.443 248.867 141.626 247.436 144.51C249.085 146.116 250.682 147.83 252.138 148.967C252.418 149.185 252.811 148.986 252.842 148.62C253.924 135.993 259.753 130.063 258.906 124.24Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.503 119.401C246.27 119.747 246.226 120.195 246.214 120.62C246.184 121.692 246.348 122.86 247.072 123.61C247.491 124.043 248.061 124.288 248.64 124.371C249.219 124.454 249.81 124.382 250.38 124.247C251.9 123.885 253.318 123.055 254.419 121.886C254.862 121.414 255.281 120.77 255.107 120.13C254.957 119.578 254.424 119.258 253.925 119.034C251.843 118.096 249.4 117.813 247.328 118.778C247.016 118.924 246.702 119.106 246.503 119.401Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.002 135.358C244.933 135.221 244.764 135.151 244.625 135.203C244.487 135.255 244.396 135.422 244.424 135.575C244.457 135.761 244.664 135.887 244.832 135.824C245 135.761 245.086 135.525 245.002 135.358Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.8 126.78C244.975 126.659 244.964 126.334 244.781 126.227C244.598 126.12 244.333 126.283 244.33 126.505C244.326 126.738 244.616 126.907 244.8 126.78Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.247 128.888C248.385 129.06 248.692 129.011 248.777 128.803C248.861 128.595 248.684 128.325 248.471 128.336C248.237 128.348 248.095 128.699 248.247 128.888Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.181 139.704C245.95 139.762 245.871 140.142 246.058 140.298C246.245 140.454 246.574 140.285 246.574 140.033C246.574 139.829 246.368 139.656 246.181 139.704Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.511 139.181C251.585 139.078 251.661 138.973 251.692 138.848C251.723 138.723 251.698 138.573 251.6 138.497C251.446 138.376 251.201 138.532 251.185 138.735C251.169 138.938 251.328 139.12 251.511 139.181Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.08 143.635C251.08 143.83 250.931 143.987 250.748 143.987C250.565 143.987 250.416 143.83 250.416 143.635C250.416 143.441 250.565 143.283 250.748 143.283C250.931 143.283 251.08 143.441 251.08 143.635Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.885 136.947C249.054 136.947 249.191 136.802 249.191 136.622C249.191 136.443 249.054 136.297 248.885 136.297C248.716 136.297 248.579 136.443 248.579 136.622C248.579 136.802 248.716 136.947 248.885 136.947Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.159 130.827C245.328 130.827 245.465 130.682 245.465 130.503C245.465 130.323 245.328 130.178 245.159 130.178C244.99 130.178 244.853 130.323 244.853 130.503C244.853 130.682 244.99 130.827 245.159 130.827Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.458 147.047C252.458 147.212 252.333 147.345 252.177 147.345C252.022 147.345 251.896 147.212 251.896 147.047C251.896 146.882 252.022 146.749 252.177 146.749C252.333 146.749 252.458 146.883 252.458 147.047Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.762 143.202C247.762 143.337 247.659 143.446 247.532 143.446C247.405 143.446 247.302 143.337 247.302 143.202C247.302 143.067 247.405 142.958 247.532 142.958C247.659 142.959 247.762 143.068 247.762 143.202Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.729 139.411C243.729 139.635 243.558 139.817 243.346 139.817C243.135 139.817 242.963 139.635 242.963 139.411C242.963 139.187 243.135 139.005 243.346 139.005C243.558 139.005 243.729 139.187 243.729 139.411Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.989 105.134C251.305 104.893 250.835 104.037 250.114 104.071C249.426 104.104 249.027 104.926 248.397 105.221C247.804 105.5 247.023 105.298 246.547 105.766C246.025 106.28 246.249 107.193 246.065 107.923C245.899 108.581 245.4 109.071 244.994 109.599C244.588 110.127 244.248 110.831 244.475 111.468C244.612 111.852 244.945 112.18 244.91 112.588C244.894 112.77 244.806 112.934 244.754 113.108C244.621 113.556 244.742 114.042 244.892 114.484C245.043 114.926 244.914 115.314 244.91 115.783C244.905 116.253 244.508 116.635 244.608 117.417C248.974 118.259 253.308 118.813 257.627 117.736C257.311 117.442 257.316 116.653 257.518 116.26C257.65 116.004 257.898 115.753 257.814 115.474C257.734 115.209 257.384 115.185 257.201 114.985C256.736 114.477 256.679 113.825 256.893 113.621C257.243 113.29 257.229 112.676 257.23 112.178C257.232 111.134 256.303 110.398 255.821 109.487C255.429 108.748 255.334 107.878 255.083 107.072C254.833 106.266 254.336 105.446 253.556 105.259C253.043 105.136 252.488 105.309 251.989 105.134Z",
    fill: "url(#paint34_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.778 107.899C246.482 108.269 246.228 108.757 246.362 109.221C246.449 109.521 246.688 109.765 246.713 110.077C246.77 110.783 245.759 111.134 245.712 111.84C245.687 112.228 245.966 112.553 246.096 112.916C246.271 113.401 246.173 113.948 246.012 114.438C245.852 114.929 245.629 115.402 245.553 115.915C245.477 116.428 245.58 117.012 245.963 117.335C246.17 117.509 246.431 117.587 246.686 117.658C248.065 118.042 249.479 118.321 250.906 118.322C252.332 118.323 253.774 118.037 255.04 117.341C255.077 117.321 255.116 117.298 255.137 117.26C255.206 117.135 255.046 117.018 254.933 116.936C254.64 116.723 254.553 116.297 254.595 115.922C254.638 115.548 254.783 115.195 254.854 114.825C254.926 114.456 254.911 114.034 254.676 113.751C254.331 113.336 253.704 113.407 253.238 113.159C252.675 112.859 252.436 112.151 252.287 111.502C252.138 110.852 252.002 110.144 251.527 109.704C251.007 109.222 250.175 109.163 249.788 108.557C249.574 108.22 249.546 107.778 249.325 107.447C249.037 107.016 248.466 106.874 247.983 107.006C247.501 107.138 247.1 107.496 246.778 107.899Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.651 118.512C249.328 116.875 249.445 115.303 249.607 113.523C250.771 113.87 251.749 113.922 252.952 113.793C253.197 115.488 253.442 117.183 253.686 118.878C253.953 118.993 254.194 119.21 254.262 119.504C254.343 119.86 254.161 120.218 253.972 120.524C253.304 121.603 252.43 122.585 251.312 123.098C250.195 123.611 248.807 123.581 247.843 122.793C246.879 122.005 246.525 120.393 247.247 119.353C247.466 119.037 248.323 118.683 248.651 118.512Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.179 119.297C253.383 121.924 250.828 123.558 248.272 122.541C247.895 122.541 247.347 122.078 246.984 121.454C247.138 121.978 247.435 122.46 247.844 122.793C248.808 123.581 250.196 123.612 251.313 123.099C252.43 122.586 253.304 121.604 253.972 120.524C254.161 120.219 254.344 119.86 254.262 119.505C254.244 119.43 254.216 119.361 254.179 119.297Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.649 113.821C251.582 113.91 250.671 113.841 249.607 113.523C249.445 115.304 249.329 116.875 248.651 118.513C248.323 118.683 247.466 119.038 247.248 119.353C246.986 119.73 246.867 120.182 246.866 120.643C248.26 119.659 249.991 119.053 251.54 118.642C252.618 118.261 252.431 115.866 252.649 113.821Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.116 117.072C249.397 115.928 249.493 114.778 249.606 113.523C250.605 113.822 251.467 113.901 252.452 113.836C252.39 115.98 250.905 116.754 249.116 117.072Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.033 110.321C247.141 110.136 247.158 109.895 247.144 109.65C247.117 109.163 247.256 108.386 247.414 107.927L247.714 107.048C249.48 106.075 251.538 106.466 253.069 107.816C253.694 108.366 254.206 109.118 254.293 109.974C254.379 110.83 254.036 111.662 253.701 112.446C253.326 113.323 252.935 114.224 252.272 114.881C251.646 115.501 250.818 115.855 249.977 116.029C249.389 116.151 248.791 116.191 248.192 116.206C247.729 116.218 247.315 115.899 247.176 115.43C246.786 114.116 246.472 112.778 246.626 111.351C246.666 110.974 246.844 110.642 247.033 110.321Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.293 109.974C254.206 109.117 253.693 108.365 253.069 107.815C251.903 106.787 250.431 106.318 249.016 106.581C249.194 106.677 249.358 106.797 249.497 106.944C250.547 107.687 250.397 109.703 251.619 110.537C252.011 110.805 252.254 111.255 252.221 111.749C252.163 112.644 252.317 113.573 252.731 114.333C253.133 113.765 253.422 113.099 253.7 112.446C254.036 111.661 254.379 110.83 254.293 109.974Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.488 114.687C255.583 113.895 255.828 113.115 255.793 112.317C255.767 111.729 255.585 111.149 255.274 110.661C255.201 110.548 255.12 110.441 255.033 110.339C255.039 110.25 255.046 110.16 255.05 110.071C255.082 109.357 255.059 108.616 254.771 107.97C254.417 107.175 253.702 106.622 252.945 106.264C251.929 105.782 250.655 105.537 249.549 105.672L248.477 106.186C248.93 106.064 250.286 106.498 250.523 106.924C250.733 107.303 250.724 107.772 250.855 108.189C251.013 108.692 251.389 109.113 251.854 109.307C252.206 109.455 252.64 109.506 252.844 109.844C253.038 110.166 252.924 110.585 252.836 110.956C252.712 111.472 252.651 112.013 252.733 112.539C252.776 112.81 252.861 113.077 252.986 113.318C253.03 113.632 253.264 113.926 253.515 114.126C253.845 114.389 254.239 114.601 254.431 114.988C254.653 115.435 254.553 116.024 254.838 116.429C255.104 116.807 255.603 116.882 256.047 116.912C255.485 116.379 255.393 115.479 255.488 114.687Z",
    fill: "url(#paint35_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.882 111.757C244.985 111.882 245.131 111.982 245.17 112.142C245.22 112.341 245.086 112.531 245.007 112.719C244.826 113.142 244.935 113.684 245.261 113.994C245.116 113.582 245.137 113.107 245.318 112.711C245.423 112.482 245.584 112.25 245.542 111.999C245.486 111.663 245.102 111.498 244.989 111.179C244.901 110.931 244.997 110.653 245.123 110.425C245.248 110.195 245.407 109.977 245.454 109.717C245.195 109.996 244.929 110.285 244.784 110.646C244.638 111.006 244.638 111.461 244.882 111.757Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.673 114.626C245.449 115.067 245.22 115.519 245.147 116.015C245.074 116.511 245.184 117.067 245.545 117.392C245.329 116.483 245.375 115.507 245.673 114.626Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.51 109.175C253.837 109.259 254.016 109.654 254.011 110.011C254.005 110.368 253.866 110.705 253.773 111.048C253.679 111.392 253.635 111.781 253.807 112.089C253.973 112.386 254.296 112.532 254.572 112.715C254.848 112.898 255.116 113.202 255.057 113.542C255.014 113.784 254.81 113.982 254.817 114.229C254.822 114.414 254.947 114.57 255.081 114.689C255.214 114.809 255.366 114.913 255.46 115.068C255.568 115.245 255.587 115.47 255.554 115.678C255.522 115.886 255.441 116.082 255.362 116.275C255.572 116.121 255.716 115.869 255.749 115.6C255.782 115.331 255.702 115.049 255.536 114.843C255.442 114.726 255.321 114.63 255.26 114.491C255.165 114.272 255.249 114.014 255.346 113.795C255.443 113.576 255.556 113.342 255.514 113.105C255.46 112.799 255.175 112.61 254.913 112.471C254.651 112.332 254.359 112.176 254.259 111.883C254.142 111.536 254.347 111.171 254.42 110.811C254.556 110.131 254.137 109.377 253.51 109.175Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.574 113.062C256.717 112.778 256.947 112.504 256.91 112.184C256.874 111.872 256.595 111.662 256.328 111.524C256.447 111.605 256.567 111.687 256.659 111.8C256.751 111.913 256.813 112.063 256.792 112.21C256.762 112.426 256.577 112.57 256.435 112.728C256.052 113.158 255.957 113.849 256.21 114.376C256.343 114.654 256.559 114.883 256.674 115.17C256.829 115.554 256.783 116.003 256.636 116.39C256.49 116.778 256.251 117.117 256.015 117.451C256.288 117.21 256.563 116.965 256.767 116.657C256.97 116.349 257.097 115.965 257.034 115.595C256.962 115.169 256.659 114.832 256.506 114.431C256.34 113.994 256.366 113.479 256.574 113.062Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.608 105.495C250.138 105.613 250.556 106.032 250.944 106.433C250.106 105.814 248.935 105.749 248.041 106.273C248.331 105.693 249.002 105.359 249.608 105.495Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.274 107.641C252.086 107.416 251.965 107.138 251.845 106.866C251.724 106.594 251.599 106.318 251.405 106.098C251.212 105.878 250.936 105.72 250.653 105.748C250.913 105.854 251.098 106.103 251.23 106.363C251.363 106.623 251.457 106.904 251.611 107.151C251.765 107.397 251.996 107.612 252.274 107.641Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.208 106.456C252.258 106.798 252.505 107.099 252.817 107.2C252.812 106.968 252.714 106.74 252.552 106.584C252.389 106.429 252.426 106.438 252.208 106.456Z",
    fill: "#F9C849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.063 141.303L255.107 141.865C255.293 138.15 255.109 134.413 254.556 130.74C254.137 127.964 253.523 125.03 254.503 122.418C254.877 121.42 255.604 120.435 256.611 120.327C257.295 120.255 257.972 120.616 258.445 121.143C258.919 121.67 259.216 122.347 259.457 123.029C260.715 126.61 260.451 129.349 260.123 133.154C259.902 135.734 259.941 138.785 259.063 141.303Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.279 123.135C253.637 125.561 254.175 128.215 254.556 130.74C255.11 134.414 255.294 138.15 255.108 141.865L256.196 141.71C256.809 135.552 255.903 129.075 254.279 123.135Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.981 123.408C256.122 123.408 256.236 123.287 256.236 123.137C256.236 122.988 256.122 122.866 255.981 122.866C255.84 122.866 255.725 122.988 255.725 123.137C255.725 123.287 255.84 123.408 255.981 123.408Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.89 125.791C259.116 125.791 259.298 125.597 259.298 125.357C259.298 125.118 259.116 124.924 258.89 124.924C258.665 124.924 258.482 125.118 258.482 125.357C258.482 125.597 258.665 125.791 258.89 125.791Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.052 129.934C257.052 130.128 256.904 130.286 256.72 130.286C256.537 130.286 256.388 130.128 256.388 129.934C256.388 129.739 256.537 129.581 256.72 129.581C256.904 129.582 257.052 129.739 257.052 129.934Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.554 130.394C259.723 130.394 259.86 130.249 259.86 130.069C259.86 129.89 259.723 129.744 259.554 129.744C259.385 129.744 259.248 129.89 259.248 130.069C259.248 130.249 259.385 130.394 259.554 130.394Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.839 135.078C258.839 135.243 258.713 135.376 258.558 135.376C258.403 135.376 258.277 135.243 258.277 135.078C258.277 134.914 258.403 134.78 258.558 134.78C258.713 134.78 258.839 134.914 258.839 135.078Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.275 128.662C254.125 128.897 253.762 129.077 253.683 129.347C253.659 129.429 253.742 129.478 253.74 129.565C253.731 130.007 253.757 130.449 253.803 130.889C253.121 131.604 252.374 131.616 251.64 131.928L251.556 131.099C251.525 130.914 251.425 130.676 251.328 130.519C251.231 130.363 251.08 130.256 250.957 130.122C250.682 129.824 250.552 129.404 250.507 128.989C250.463 128.575 250.495 128.156 250.496 127.738C250.499 126.52 250.242 125.318 250.137 124.105C250.123 123.947 250.114 123.778 250.186 123.639C250.312 123.62 250.5 123.819 250.535 123.95C250.739 124.73 250.91 125.296 251.045 126.314C251.207 126.089 251.115 125.83 251.101 125.548C251.087 125.265 251.036 124.886 250.98 124.61C250.883 124.125 250.79 123.762 250.785 123.267C250.783 123.156 250.895 122.903 250.994 122.864C251.131 122.812 251.188 122.929 251.222 123.079C251.176 122.872 251.223 122.881 251.222 122.753C251.222 122.626 251.335 122.492 251.453 122.518C251.82 122.988 252.285 123.795 252.404 124.392C252.524 124.99 252.535 125.212 252.496 125.978C252.631 125.379 252.592 124.738 252.386 124.162C252.29 123.893 252.158 123.638 252.09 123.36C252.022 123.082 252.027 122.765 252.186 122.533C252.823 123.531 253.486 124.616 253.457 125.822C253.446 126.321 253.314 126.832 253.445 127.312C253.664 127.161 253.888 127.003 254.033 126.773C254.156 126.577 254.212 126.343 254.315 126.134C254.418 125.925 254.594 125.729 254.816 125.721C254.872 125.719 254.933 125.733 254.969 125.778C255.011 125.833 255.004 125.912 254.991 125.981C254.882 126.578 254.558 127.115 254.474 127.716C254.428 128.039 254.447 128.391 254.275 128.662Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.759 129.837C250.815 129.939 250.879 130.036 250.958 130.121C251.081 130.255 251.231 130.363 251.328 130.519C251.426 130.675 251.525 130.913 251.557 131.098L251.641 131.927C252.374 131.615 253.122 131.603 253.803 130.889C253.758 130.449 253.731 130.007 253.74 129.564C253.742 129.481 253.665 129.431 253.683 129.352C252.738 129.818 251.776 129.909 250.759 129.837Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.275 128.662C254.447 128.391 254.428 128.038 254.474 127.715C254.559 127.114 254.883 126.577 254.992 125.981C255.005 125.912 255.012 125.832 254.97 125.778C254.934 125.732 254.873 125.718 254.817 125.721C254.595 125.728 254.418 125.925 254.315 126.133C254.212 126.342 254.156 126.576 254.034 126.773C253.889 127.003 253.664 127.16 253.446 127.311C253.315 126.831 253.446 126.321 253.458 125.821C253.487 124.616 252.824 123.53 252.187 122.532C252.027 122.764 252.023 123.081 252.091 123.359C252.159 123.638 252.291 123.893 252.387 124.161C252.593 124.736 252.632 125.378 252.496 125.977C252.535 125.211 252.524 124.989 252.405 124.391C252.286 123.793 251.821 122.987 251.453 122.517C251.335 122.491 251.222 122.624 251.223 122.752C251.224 122.88 251.177 122.871 251.223 123.078C251.188 122.928 251.132 122.81 250.995 122.863C250.896 122.901 250.785 123.154 250.786 123.266C250.791 123.761 250.884 124.124 250.981 124.608C251.037 124.885 251.088 125.264 251.102 125.546C251.116 125.829 251.208 126.088 251.046 126.313C250.911 125.295 250.74 124.728 250.536 123.949C250.502 123.818 250.313 123.619 250.187 123.638C250.115 123.777 250.124 123.946 250.138 124.104C250.243 125.317 250.5 126.519 250.497 127.737C250.495 128.155 250.464 128.574 250.509 128.988C250.54 129.284 250.618 129.581 250.759 129.836C251.776 129.909 252.738 129.818 253.684 129.352C253.684 129.35 253.684 129.348 253.684 129.346C253.762 129.077 254.126 128.896 254.275 128.662Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.999 126.208L251.795 126.205C251.809 125.083 251.538 123.977 251.01 123.005L251.187 122.896C251.734 123.902 252.014 125.047 251.999 126.208Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.397 143.161C256.479 143.33 255.367 142.99 254.806 142.2C254.245 141.41 253.703 140.28 253.445 139.33C252.67 136.479 251.939 133.516 251.165 130.665C252.17 130.614 253.549 130.03 254.061 129.11C254.966 131.449 255.982 133.752 257.305 135.855C258.07 137.072 258.961 138.275 259.207 139.715C259.453 141.155 258.757 142.911 257.397 143.161Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.078 139.063C258.073 137.156 257.212 135.362 256.369 133.859C256.124 133.421 255.877 133.016 255.637 132.624C254.996 131.574 254.389 130.582 254.013 129.257L254.209 129.195C254.576 130.49 255.175 131.469 255.809 132.506C256.049 132.899 256.298 133.307 256.545 133.747C257.401 135.276 258.277 137.102 258.282 139.061L258.078 139.063Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.674 140.088C255.843 140.088 255.98 139.943 255.98 139.763C255.98 139.584 255.843 139.438 255.674 139.438C255.505 139.438 255.368 139.584 255.368 139.763C255.368 139.943 255.505 140.088 255.674 140.088Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.287 136.351C256.428 136.351 256.542 136.23 256.542 136.081C256.542 135.931 256.428 135.81 256.287 135.81C256.146 135.81 256.031 135.931 256.031 136.081C256.031 136.23 256.146 136.351 256.287 136.351Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.734 134.537C253.734 134.672 253.631 134.781 253.504 134.781C253.377 134.781 253.275 134.672 253.275 134.537C253.275 134.402 253.377 134.293 253.504 134.293C253.631 134.293 253.734 134.403 253.734 134.537Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.245 131.991C254.245 132.126 254.142 132.235 254.015 132.235C253.888 132.235 253.785 132.126 253.785 131.991C253.785 131.857 253.888 131.748 254.015 131.748C254.142 131.748 254.245 131.857 254.245 131.991Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.437 171.897C230.72 171.897 230.109 171.328 230.014 170.575L228.545 158.852C228.345 157.29 228.096 155.347 228.808 153.971C229.299 153.022 229.85 152.041 230.716 151.405C232.298 150.242 234.183 149.46 236.006 148.704C238.272 147.765 240.413 146.877 241.911 145.337L242.053 145.492C240.526 147.063 238.367 147.958 236.081 148.906C234.269 149.657 232.396 150.434 230.832 151.583C230.003 152.192 229.466 153.148 228.986 154.075C228.307 155.389 228.551 157.293 228.747 158.822L228.788 159.143L230.217 170.546C230.297 171.193 230.822 171.68 231.437 171.68L231.437 171.897Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.869 95.5847C133.039 96.696 132.758 97.8836 132.117 98.757C131.714 100.851 130.129 102.603 128.243 103.038C126.471 102.232 125.26 100.101 125.367 97.9737C125.475 95.8468 126.891 93.8795 128.734 93.2985C129.757 92.9761 130.972 93.1078 131.711 93.9566L132.869 95.5847Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.919 93.1413C129.52 93.1223 129.114 93.1786 128.734 93.2986C126.891 93.8796 125.474 95.847 125.367 97.9738C125.26 100.101 126.47 102.232 128.243 103.038C128.424 102.996 128.6 102.94 128.773 102.875C128.126 99.5149 128.067 95.8539 129.919 93.1413Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.306 104.42C121.107 104.181 121.294 103.814 121.474 103.559C122.926 101.492 123.975 99.2189 124.334 96.6697C125.812 97.3248 127.278 97.6103 128.861 97.8672C128.196 100.657 127.733 103.502 127.478 106.367C125.528 105.775 123.578 105.183 121.629 104.592C121.511 104.557 121.387 104.516 121.306 104.42Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.139 95.347C135.01 95.0575 135.7 94.2231 135.855 93.2682C135.276 93.6049 134.577 93.7041 133.934 93.5412C134.119 93.549 134.306 93.4632 134.427 93.3146C133.663 93.2634 132.962 92.8506 132.349 92.3653C131.736 91.8801 131.18 91.3125 130.534 90.8771C129.888 90.4417 129.119 90.1401 128.364 90.2693C128.272 90.2848 128.183 90.3147 128.094 90.3425C127.655 90.2883 127.212 90.3043 126.783 90.4222C125.322 90.8234 124.286 92.3021 123.957 93.8648C123.628 95.4275 123.463 97.2637 123.86 98.8086C125.347 99.5573 127.526 99.5001 129.105 99.004C129.324 98.9351 129.538 98.8494 129.749 98.7562C129.844 98.4508 129.876 98.1245 129.926 97.8057C129.983 97.4335 130.08 97.0488 130.324 96.7737C130.568 96.499 130.997 96.3777 131.287 96.5947C131.478 96.7368 131.571 96.9916 131.582 97.2385C131.588 97.3503 131.577 97.4612 131.56 97.5717C131.87 97.2901 132.16 96.9833 132.418 96.648C133.484 96.7399 134.59 96.1862 135.171 95.2274C134.839 95.334 134.487 95.3747 134.139 95.347Z",
    fill: "url(#paint36_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.916 97.8606C130.969 97.7796 131.056 97.7315 131.126 97.6665C131.278 97.5257 131.349 97.2844 131.274 97.0855C131.199 96.8871 130.968 96.7628 130.781 96.8394C130.598 96.914 130.506 97.138 130.5 97.345C130.494 97.5664 130.561 97.7818 130.629 97.9915C130.548 97.923 130.423 97.9208 130.341 97.9867C130.258 98.0525 130.226 98.1804 130.266 98.2813C130.294 98.3524 130.351 98.4052 130.396 98.4659C130.441 98.5265 130.476 98.6075 130.449 98.6795C130.433 98.7232 130.396 98.7553 130.376 98.7973C130.355 98.8393 130.361 98.9043 130.404 98.9169C130.431 98.9247 130.459 98.9073 130.481 98.8892C130.669 98.7401 130.798 98.5092 130.83 98.2627C130.849 98.1253 130.841 97.9746 130.916 97.8606Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.188 92.5083C130.367 92.6179 130.343 92.9082 130.477 93.0737C130.632 93.266 130.915 93.2166 131.153 93.2197C131.59 93.2249 132.002 93.4645 132.318 93.7855C132.633 94.1061 132.868 94.5047 133.099 94.8985C133.252 94.6416 133.405 94.3847 133.558 94.1278C131.996 93.1629 130.434 92.1981 128.871 91.2328C128.949 91.6413 129.027 92.0495 129.105 92.458C129.119 92.5325 129.134 92.6105 129.182 92.6677C129.302 92.8137 129.527 92.7349 129.683 92.6326C129.838 92.5299 130.03 92.4112 130.188 92.5083Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.833 169.968C107.442 171.027 106.909 174.823 106.388 176.187C105.984 177.241 105.585 177.8 106.187 178.743C106.788 179.685 108.683 180.71 109.66 180.241C112.385 172.772 115.611 165.511 118.15 157.969C120.69 150.427 122.546 142.511 122.391 134.503C118.306 133.129 114.222 131.755 110.138 130.38C106.307 140.092 108.837 142.979 109.198 150.089C109.559 157.197 110.28 163.338 107.833 169.968Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.391 134.503C119.395 133.495 116.4 132.487 113.404 131.479C109.325 141.158 113.071 151.963 112.286 161.967C111.738 168.363 110.289 174.41 108.199 180.189C108.739 180.376 109.272 180.427 109.66 180.241C112.386 172.772 115.611 165.511 118.151 157.969C120.69 150.427 122.546 142.511 122.391 134.503Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.106 131.379C116.201 132.421 119.296 133.462 122.391 134.503C122.547 142.511 120.69 150.426 118.151 157.969C116.493 162.892 114.544 167.695 112.632 172.513C112.95 170.736 113.109 168.931 113.374 167.241C115.83 154.863 107.145 143.107 113.106 131.379Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.881 132.167L111.125 129.245C114.914 131.083 119.257 133.068 123.375 133.738C123.375 143.291 124.242 151.434 123.974 160.199C123.724 168.343 122.385 177.117 121.269 185.678C119.436 186.156 118.151 186.283 116.475 185.001C116.385 177.764 115.983 172.141 116.385 168.946C116.785 165.766 115.352 157.909 114.458 154.804C111.66 145.091 108.984 143.614 110.881 132.167Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.228 158.935C118.478 150.18 114.632 140.695 116.857 131.822C114.876 131.035 112.937 130.124 111.125 129.245L110.881 132.167C108.984 143.614 111.661 145.091 114.458 154.803C115.352 157.908 116.785 165.765 116.385 168.945C115.983 172.14 116.385 177.763 116.475 185C117.262 185.602 117.963 185.891 118.675 185.981C119.363 177.001 119.887 168.031 119.228 158.935Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.317 185.435C123.363 169.306 122.313 152.462 120.895 136.658L121.206 136.611C122.351 152.68 123.529 169.258 120.541 185.35C120.428 185.375 120.43 185.409 120.317 185.435Z",
    fill: "url(#paint37_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.548 103.582C117.15 103.317 115.773 104.453 115.245 105.852C114.716 107.25 114.853 108.827 115.121 110.307C115.865 114.413 117.544 118.295 119.781 121.738C120.665 123.1 121.647 124.408 122.853 125.455C125.899 128.098 130.001 128.801 133.894 129.41C134.275 128.521 134.658 127.631 135.039 126.742C130.641 124.24 127.009 120.251 124.805 115.501C123.27 112.193 122.429 108.58 121.599 104.999L118.548 103.582Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.855 133.729H132.032L135.234 119.881H143.058L139.855 133.729Z",
    fill: "#001F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.494 131.563H132.894L135.596 119.881H142.195L139.494 131.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.596 119.881L133.103 130.66C135.22 128.027 137.645 126.054 140.783 125.986L142.195 119.881H135.596Z",
    fill: "#E7EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.116 103.399C120 102.818 120.713 101.948 121.133 100.939C124.307 101.134 127.323 103.191 128.809 106.173C127.501 105.647 126.193 105.122 124.885 104.597C123.238 103.935 121.542 103.263 119.78 103.291L119.116 103.399Z",
    fill: "url(#paint38_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.848 139.783C124.962 138.411 124.424 135.401 124.652 130.787C124.755 127.069 124.916 128.464 124.995 127.316C125.189 124.509 126.045 123.574 127.355 121.126C128.352 119.263 129.88 116.114 130.919 114.275C131.958 112.438 132.499 110.023 131.459 108.186C130.817 107.052 129.69 106.34 128.581 105.736C126.944 104.845 125.244 104.088 123.498 103.471C121.542 102.781 119.237 102.319 117.545 103.568C116.416 104.401 115.073 105.985 114.366 107.236C110.496 114.09 111.014 116.584 109.012 128.426C108.848 129.399 105.857 136.127 105.403 138.267C106.376 138.671 107.368 139.009 108.375 139.284C108.842 136.437 109.553 133.684 110.567 131.173C110.567 134.378 109.709 136.602 109.884 139.647C114.678 140.665 119.775 140.436 124.848 139.783Z",
    fill: "url(#paint39_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.041 103.62C122.234 103.791 124.405 104.262 126.485 105.017C124.659 103.721 122.483 102.986 120.287 102.923C120.119 102.918 119.942 102.92 119.798 103.012C119.655 103.104 119.57 103.321 119.666 103.467C119.745 103.588 119.902 103.609 120.041 103.62Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.906 103.204C117.582 103.649 116.428 104.64 115.743 105.921C116.797 105.016 117.852 104.11 118.906 103.204Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.412 107.557C128.829 108.408 128.246 109.26 127.663 110.111C127.879 109.052 128.53 108.102 129.412 107.557Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.232 140.076C123.104 139.993 123.976 139.895 124.848 139.783C124.962 138.41 124.424 135.401 124.652 130.787C124.755 127.069 124.916 128.463 124.995 127.316C125.189 124.509 126.045 123.574 127.355 121.126C128.352 119.262 129.88 116.114 130.919 114.275C131.884 112.569 132.417 110.367 131.656 108.59C121.015 114.592 121.137 127.869 122.232 140.076Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.339 109.122C136.951 108.762 137.605 108.484 138.282 108.297C137.951 107.579 137.797 106.77 137.84 105.973C137.865 105.516 137.932 104.989 137.629 104.663C137.46 104.479 137.212 104.41 136.977 104.347C136.434 104.203 135.892 104.06 135.349 103.916C134.811 103.773 134.652 103.952 134.363 103.451C134.249 103.254 133.759 102.66 133.621 102.482C133.483 102.303 133.112 101.529 132.755 101.881C132.591 102.042 132.964 102.81 133.053 103.027C133.278 103.583 133.504 104.139 133.729 104.696C133.909 105.14 134.025 105.442 133.687 105.767C133.566 105.882 133.286 105.888 133.151 105.983C133.015 106.078 133.059 106.583 133.113 106.746C133.146 106.848 133.236 106.914 133.32 106.974C134.326 107.69 135.333 108.406 136.339 109.122Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.838 108.376C138.625 107.957 138.413 107.538 138.201 107.119C137.282 107.088 136.356 107.453 135.678 108.113C135.569 108.219 135.459 108.352 135.466 108.508C135.47 108.59 135.506 108.665 135.542 108.737C135.816 109.301 136.091 109.865 136.365 110.428C137.153 109.553 137.886 109.089 139.003 108.849L138.838 108.376Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.24 125.266C142.961 124.993 143.44 124.251 143.688 123.483C144.153 122.04 143.959 120.44 143.507 118.992C143.056 117.543 142.361 116.196 141.802 114.79C141.042 112.876 140.533 110.849 139.65 108.995C139.461 108.597 139.251 108.153 138.866 107.973C138.381 107.746 137.783 108.016 137.184 108.097C136.768 108.153 136.396 108.608 135.983 108.805C135.709 108.935 135.571 109.26 135.643 109.569C136.282 112.282 136.814 114.904 137.124 117.7C137.288 119.181 137.412 120.688 137.917 122.079C138.423 123.469 139.382 124.757 140.716 125.225C141.208 125.397 141.752 125.45 142.24 125.266Z",
    fill: "url(#paint40_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.984 108.804C135.71 108.934 135.571 109.26 135.644 109.569C136.283 112.282 136.815 114.904 137.125 117.7C137.289 119.18 137.412 120.688 137.918 122.078C138.423 123.469 139.383 124.757 140.717 125.225C140.74 125.233 140.765 125.237 140.789 125.245C140.447 119.391 138.919 113.607 136.753 108.281C136.498 108.445 136.25 108.678 135.984 108.804Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.173 112.812C127.462 110.829 128.536 108.987 130.081 107.829C130.403 107.587 130.784 107.366 131.172 107.438C131.488 107.496 131.742 107.737 131.973 107.972C134.905 110.957 137.109 114.672 140.051 117.645C140.856 118.459 141.719 119.22 142.392 120.16C143.065 121.099 143.542 122.263 143.426 123.436C143.311 124.609 142.479 125.744 141.375 125.885C140.527 125.992 139.71 125.529 139.007 125.014C137.757 124.096 136.658 122.97 135.508 121.914C133.64 120.199 131.625 118.665 129.496 117.335C128.83 116.919 128.131 116.503 127.679 115.837C127.099 114.984 127.022 113.851 127.173 112.812Z",
    fill: "url(#paint41_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.789 118.299C141.968 119.376 142.658 121.03 142.617 122.68C142.873 121.849 142.829 120.918 142.495 120.118C142.162 119.318 141.541 118.657 140.789 118.299Z",
    fill: "#4C9BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.463 124.708C137.032 119.249 131.009 117.151 127.233 112.511C127.214 112.612 127.188 112.711 127.173 112.813C127.022 113.851 127.099 114.985 127.678 115.838C128.13 116.503 128.829 116.919 129.495 117.335C131.624 118.665 133.639 120.2 135.507 121.914C136.657 122.97 137.756 124.097 139.006 125.014C139.645 125.482 140.378 125.902 141.142 125.895C140.912 125.512 140.683 125.118 140.463 124.708Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.788 129.476C111.101 121.616 113.193 113.842 116.84 106.993C113.001 113.745 110.889 121.591 110.788 129.476Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.653 120.735C177.575 124.885 178.59 128.88 179.335 132.655C182.545 148.909 185.987 164.248 189.529 180.725C190.827 180.251 193.527 179.746 194.825 179.271C193.802 159.324 191.618 140.347 188.451 120.735H177.653Z",
    fill: "url(#paint42_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.653 120.735C177.575 124.885 178.59 128.88 179.335 132.655C182.545 148.909 185.987 164.248 189.529 180.725C190.218 180.473 191.301 180.213 192.36 179.953C189.482 159.671 184.204 140.194 178.013 120.735H177.653Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.624 180.308C190.054 177.347 189.516 174.813 188.982 172.017C186.396 158.474 184.264 146.842 181.028 132.795L181.17 132.669C184.408 146.721 186.642 158.419 189.229 171.965C189.762 174.759 190.19 177.275 190.76 180.236L190.624 180.308Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.001 120.735L170.863 122.181C169.631 134.431 168.586 142.467 168.517 152.565C168.448 162.664 168.858 172.805 167.804 182.83C170.001 182.591 172.225 182.697 174.397 183.146C175.918 164.09 179.159 147.694 181.983 130.11C182.402 127.499 182.19 124.117 181.873 120.735H171.001Z",
    fill: "url(#paint43_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.337 136.839C175.916 129.411 179.258 136.081 181.458 120.735H171.002L170.863 122.181C169.631 134.431 168.587 142.467 168.517 152.565C168.448 162.664 168.858 172.805 167.805 182.83C168.37 182.769 168.938 182.731 169.506 182.715C169.399 169.338 168.902 149.385 173.337 136.839Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.303 182.655L173.135 182.572C174.456 165.165 177.273 149.626 181.096 131.651L181.266 131.748C177.445 149.712 174.622 165.263 173.303 182.655Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.055 124.668C179.043 124.276 179.069 123.829 179.035 123.41C176.681 123.509 174.329 123.674 171.984 123.916C171.779 124.616 171.575 125.315 171.371 126.015C173.921 125.576 176.494 125.287 179.074 125.143C179.068 124.985 179.06 124.827 179.055 124.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.529 123.39C179.559 123.818 179.538 124.262 179.551 124.668C179.556 124.818 179.563 124.968 179.569 125.118C179.827 125.106 180.085 125.093 180.344 125.083C180.34 124.509 180.349 123.933 180.357 123.358C180.081 123.366 179.805 123.38 179.529 123.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.555 125.094C186.556 125.133 187.556 125.191 188.554 125.275C188.451 124.644 188.347 124.012 188.244 123.38C187.339 123.347 186.434 123.329 185.528 123.318C185.541 123.911 185.537 124.504 185.555 125.094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.062 125.077C185.045 124.491 185.048 123.902 185.034 123.314C184.717 123.311 184.401 123.305 184.085 123.305C184.21 123.877 184.214 124.464 184.206 125.054C184.492 125.06 184.777 125.068 185.062 125.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.587 123.307C182.676 123.311 181.764 123.321 180.853 123.346C180.844 123.919 180.836 124.493 180.839 125.066C181.808 125.037 182.777 125.035 183.745 125.048C183.756 124.453 183.741 123.862 183.587 123.307Z",
    fill: "url(#paint44_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.618 96.3516C177.675 96.5015 177.642 96.6705 177.608 96.8282C177.427 97.6817 177.245 98.5347 177.064 99.3883C175.655 98.2657 175.609 95.9695 174.387 94.6229C175.32 95.0757 176.252 95.528 177.185 95.9807C177.359 96.0648 177.547 96.1649 177.618 96.3516Z",
    fill: "url(#paint45_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.779 93.9623C179.823 91.8315 175.229 91.6318 169.86 92.2323C168.521 92.3822 167.067 92.6877 166.226 93.7301C165.248 94.9414 165.45 96.6831 165.752 98.2042C167.437 106.713 170.678 115.061 170.382 123.727C176.463 122.735 182.662 122.449 188.81 122.874C187.358 115.7 187.089 109.193 188.306 101.977C188.589 100.299 188.384 97.9348 187.344 96.5809C186.779 95.8456 185.635 94.3301 184.779 93.9623Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.367 86.7091C176.797 87.0042 174.325 87.1519 172.755 86.8534C173.196 89.2059 173.443 90.2353 172.676 92.4917C182.535 95.213 179.81 94.6177 179.993 93.9548C178.633 91.8535 178.626 89.2423 178.367 86.7091Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.993 93.9549C178.633 91.8541 178.626 89.2429 178.367 86.7092C176.988 86.9683 174.916 87.113 173.369 86.9432C173.714 89.0172 174.252 91.0621 174.858 93.0967C182.098 95.1121 179.825 94.5628 179.993 93.9549Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.105 91.9806C178.609 90.3221 178.55 88.4968 178.366 86.7092C177.022 86.9618 175.017 87.1052 173.483 86.9545C173.734 90.1237 176.328 91.7375 179.105 91.9806Z",
    fill: "url(#paint46_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.839 79.7339C175.995 79.3349 175.037 79.3115 174.148 79.5783C173.16 79.8747 171.935 80.2074 171.27 81.1463C170.63 82.0505 170.66 83.3221 171.001 84.3935C171.639 86.3951 173.011 88.1138 174.838 88.9552C176.709 89.8174 178.016 89.7385 179.556 89.4426C180.04 89.3495 180.379 88.8824 180.335 88.3629C180.229 87.1186 180.176 85.9311 179.77 84.8033C179.633 84.4247 179.278 84.1444 179.173 83.7848C179.06 83.3979 179.223 83.0487 179.086 82.6579C178.621 81.3321 178.019 80.2915 176.839 79.7339Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.989 89.3858C177.288 89.7653 178.353 89.6735 179.557 89.4421C180.041 89.349 180.379 88.8819 180.335 88.3625C180.319 88.1675 180.303 87.9743 180.288 87.7823C179.008 89.1978 177.526 89.5626 175.989 89.3858Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.95 82.6825C175.43 82.6102 175.838 82.5742 177.063 82.141C177.795 82.0327 178.253 81.7316 178.527 81.3824C178.124 80.6614 177.6 80.0895 176.825 79.7269C175.746 79.2213 174.49 79.4449 173.364 79.8196C172.575 80.0817 171.767 80.4452 171.271 81.1458C170.63 82.05 170.66 83.3216 171.002 84.393C171.531 86.0541 172.571 87.512 173.952 88.4435C173.968 86.519 172.929 84.5416 173.95 82.6825Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.365 76.9684C179.115 77.519 178.683 77.974 178.163 78.2365C178.366 78 178.488 77.685 178.498 77.3648C177.999 78.0953 177.15 78.4687 176.313 78.6251C175.476 78.7815 174.618 78.7564 173.775 78.8747C172.932 78.993 172.067 79.2807 171.484 79.9366C170.836 80.6649 169.906 81.6553 170.213 82.7649C169.853 83.2809 169.669 83.9208 169.794 84.5434C169.954 85.3444 170.566 85.9527 171.199 86.4219C171.832 86.8911 172.53 87.2889 173.027 87.9162C173.198 87.3478 173.255 86.7503 173.272 86.1446C173.499 86.3301 173.713 86.5346 173.924 86.7404C174.076 86.7724 174.218 86.616 174.237 86.4527C174.255 86.2894 174.078 85.7114 174 85.5697C173.792 85.1941 173.622 85.2838 173.42 84.9051C173.361 84.7955 173.311 84.679 173.27 84.5589C173.268 83.7908 173.297 83.0365 173.503 82.3355C173.573 82.326 173.643 82.3143 173.715 82.3069C174.841 82.1917 175.999 82.1722 177.053 81.7355C178.106 81.2987 179.058 80.3157 179.093 79.116C178.91 79.2867 178.728 79.4574 178.546 79.6277C179.05 78.8483 179.338 77.9133 179.365 76.9684Z",
    fill: "url(#paint47_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.32 86.6307C174.288 86.3639 173.049 85.5758 172.808 85.6585C172.567 85.7413 172.411 86.0064 172.383 86.2733C172.354 86.5402 172.432 86.8079 172.535 87.0536C172.675 87.3898 172.865 87.703 173.094 87.9782C173.267 88.1852 173.473 88.3767 173.725 88.4469C173.977 88.5171 174.282 88.4326 174.411 88.1926L174.32 86.6307Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.306 101.977C188.589 100.299 188.384 97.9347 187.344 96.5808C186.779 95.8456 185.635 94.3301 184.779 93.9623C183.873 93.5728 182.979 93.2491 182.09 92.9818C185.406 102.486 184.643 112.684 185.002 122.703C186.272 122.731 187.542 122.786 188.81 122.874C187.358 115.7 187.089 109.193 188.306 101.977Z",
    fill: "url(#paint48_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.691 122.819C182.658 122.819 182.626 122.801 182.609 122.768C182.583 122.72 182.599 122.659 182.645 122.632L184.112 121.76C184.001 121.616 183.817 121.531 183.645 121.546C183.592 121.552 183.55 121.511 183.544 121.458C183.538 121.404 183.573 121.356 183.623 121.348C184.027 121.281 184.28 120.814 184.314 120.408C184.347 120.001 184.229 119.588 184.115 119.189L184.079 119.06C183.379 116.571 183.317 113.945 183.256 111.404C183.213 109.584 183.005 107.494 182.803 105.473C182.601 103.448 182.393 101.354 182.349 99.5252C182.348 99.4697 182.389 99.4242 182.441 99.4225C182.442 99.4225 182.443 99.4225 182.444 99.4225C182.495 99.4225 182.537 99.4658 182.538 99.52C182.581 101.341 182.79 103.43 182.991 105.452C183.193 107.476 183.402 109.57 183.445 111.399C183.505 113.926 183.567 116.539 184.26 119.002L184.297 119.131C184.416 119.548 184.539 119.979 184.503 120.425C184.472 120.8 184.288 121.203 183.982 121.412C184.128 121.481 184.255 121.598 184.331 121.747C184.356 121.795 184.339 121.855 184.294 121.882L182.738 122.807C182.722 122.815 182.706 122.819 182.691 122.819Z",
    fill: "url(#paint49_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.959 96.226C181.677 96.6848 181.711 97.6643 181.251 97.9135C182.291 104.27 182.398 109.627 181.359 115.984C182.536 116.97 183.449 117.425 184.239 118.021C184.332 116.345 184.897 116.214 184.89 115.393C184.883 114.638 184.677 113.603 184.487 111.943C183.898 106.78 183.4 101.197 181.959 96.226Z",
    fill: "url(#paint50_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.438 91.3091C171.213 91.3264 170.944 92.0764 170.715 92.0976C170.271 92.1388 170.314 92.199 169.86 92.2536C168.52 92.4139 167.067 92.7414 166.225 93.8588C165.248 95.1568 165.582 97.002 165.751 98.6536C166.928 110.153 171.961 114.646 169.383 132.229C171.417 131.874 174.092 131.245 176.504 130.856C178.021 130.611 179.114 129.187 179.027 127.561C178.58 119.153 178.3 107.313 177.324 99.7198C176.886 96.2321 174.198 93.0637 171.438 91.3091Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.914 124.3C173.109 123.965 175.124 122.489 176.196 120.429C174.54 121.869 172.724 123.086 170.914 124.3Z",
    fill: "#E7EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.607 97.2771C165.648 97.7402 165.706 98.2038 165.751 98.6535C166.001 101.094 166.425 103.219 166.913 105.22C169.093 110.566 173.45 114.587 178.544 116.943C178.393 113.563 178.222 110.123 177.999 106.926C172.675 105.106 167.82 102.41 165.607 97.2771Z",
    fill: "url(#paint51_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.315 129.833C178.265 129.833 178.223 129.791 178.221 129.738C177.882 121.204 176.59 112.711 174.381 104.496C174.373 104.469 174.377 104.44 174.391 104.416C174.405 104.392 174.428 104.376 174.454 104.37C175.106 104.242 175.739 103.979 176.301 103.604L174.547 103.364C174.521 103.361 174.498 103.345 174.482 103.322C174.467 103.299 174.461 103.271 174.467 103.244C175.291 99.1177 173.714 94.6786 170.542 92.1982C170.5 92.1657 170.491 92.1029 170.522 92.0583C170.552 92.0141 170.611 92.0041 170.654 92.0371C173.857 94.5417 175.463 99.0076 174.671 103.179L176.575 103.439C176.613 103.445 176.645 103.474 176.655 103.515C176.664 103.555 176.649 103.597 176.617 103.62C176.012 104.069 175.313 104.388 174.59 104.545C176.786 112.743 178.07 121.215 178.409 129.729C178.411 129.785 178.371 129.831 178.319 129.833C178.318 129.833 178.316 129.833 178.315 129.833Z",
    fill: "url(#paint52_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.48 132.08C169.446 132.08 169.413 132.061 169.396 132.027C169.372 131.978 169.389 131.918 169.435 131.892C170.639 131.212 172.029 131.076 173.375 130.944C173.578 130.924 173.781 130.904 173.982 130.883C175.449 130.725 177.096 130.407 178.194 129.244C178.23 129.205 178.29 129.205 178.327 129.244C178.364 129.283 178.364 129.346 178.326 129.385C177.187 130.593 175.5 130.92 174.001 131.082C173.799 131.103 173.595 131.123 173.391 131.143C172.065 131.273 170.693 131.407 169.523 132.068C169.509 132.077 169.494 132.08 169.48 132.08Z",
    fill: "url(#paint53_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.964 123.968C170.933 123.968 170.902 123.951 170.884 123.92C170.857 123.874 170.87 123.812 170.915 123.783C172.684 122.626 174.436 121.388 176.124 120.102C176.166 120.07 176.225 120.08 176.255 120.125C176.285 120.17 176.276 120.233 176.234 120.265C174.543 121.553 172.786 122.793 171.013 123.953C170.999 123.963 170.981 123.968 170.964 123.968Z",
    fill: "url(#paint54_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.464 94.3938C188.119 96.7923 187.977 98.7016 189.346 102.104C190.24 104.325 191.219 107.504 191.493 109.902C191.725 111.93 191.262 114.464 190.915 116.473C190.161 120.833 190.171 124.656 189.015 128.915C187.884 127.469 186.681 126.499 186.528 124.627C186.466 123.871 186.579 123.112 186.704 122.365C187.136 119.77 187.711 117.16 187.537 114.531C187.366 111.929 186.469 109.452 185.879 106.92C185.023 103.25 184.81 99.4511 184.601 95.6775L185.464 94.3938Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.869 99.8912C185.058 102.259 185.341 104.615 185.879 106.919C186.469 109.451 187.366 111.928 187.538 114.53C187.711 117.159 187.136 119.769 186.704 122.364C186.579 123.112 186.466 123.87 186.528 124.626C186.681 126.498 187.884 127.468 189.015 128.914C189.098 128.612 189.172 128.313 189.243 128.015C189.432 118.19 189.787 108.392 184.869 99.8912Z",
    fill: "url(#paint55_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.245 108.771C181.578 106.628 180.904 106.04 179.655 104.32C178.406 102.6 177.241 102.71 175.601 101.411C173.518 99.7622 171.425 95.7502 169.342 94.1013C168.844 93.707 168.326 93.3024 167.719 93.1607C166.527 92.8821 165.286 93.7469 164.749 94.9097C164.211 96.0726 164.25 97.4464 164.496 98.7154C165.061 101.631 166.642 104.248 168.631 106.348C170.619 108.449 173.007 110.073 175.453 111.533C176.82 112.349 178.456 113.134 179.897 112.479C181.005 111.975 181.049 110.032 181.245 108.771Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.388 99.65C165.022 97.6319 165.693 95.4371 167.104 94.0303C166.671 93.7786 166.138 94.1109 165.802 94.496C165.208 95.1775 164.835 96.0726 164.761 96.9976C164.687 97.9226 164.911 98.8714 165.388 99.65Z",
    fill: "#E7EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.366 95.1364C168.484 94.9098 168.335 94.581 168.094 94.5377C167.887 94.5 167.668 94.6776 167.647 94.8994C167.627 95.1213 167.809 95.3409 168.019 95.347C168.159 95.3509 168.298 95.2664 168.366 95.1364Z",
    fill: "#E7EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.236 101.547C174.452 103.036 174.198 104.832 174.536 106.501C174.874 108.169 175.801 109.695 177.094 110.711C176.124 108.139 176.083 105.187 176.981 102.587C176.399 102.24 175.818 101.893 175.236 101.547Z",
    fill: "url(#paint56_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.31 88.6532C179.673 88.4677 180.08 88.4123 180.479 88.359C181.017 88.2875 181.569 88.2165 182.097 88.3473C182.671 88.4898 183.054 88.878 183.561 89.0652C183.771 89.1432 183.888 89.3806 183.819 89.6055C183.741 89.855 183.67 90.089 183.576 90.3788C183.522 90.5474 183.593 90.8511 183.432 90.9009C183.264 90.9529 183.087 90.809 183.026 90.6349C182.966 90.4607 182.99 90.2679 183.016 90.0842C182.637 90.4893 182.184 90.8173 181.691 91.046C181.585 91.624 181.577 92.2223 181.666 92.8037C180.795 92.7145 179.928 92.5828 179.068 92.409C178.856 92.3661 178.618 92.3016 178.514 92.101C178.454 91.987 178.451 91.851 178.45 91.721C178.441 91.0205 178.627 90.4473 178.618 89.7467C178.796 89.3282 178.921 88.8525 179.31 88.6532Z",
    fill: "#E7A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.541 90.6772C178.494 91.0143 178.445 91.3501 178.45 91.721C178.451 91.8509 178.455 91.9874 178.514 92.1009C178.618 92.3011 178.856 92.3661 179.068 92.409C179.928 92.5827 180.795 92.7144 181.667 92.8036C181.605 92.4046 181.593 91.9978 181.624 91.5949C180.596 91.4172 179.569 91.1118 178.541 90.6772Z",
    fill: "#D88568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.462 112.93C180.296 112.713 180.918 111.933 181.218 111.08C181.518 110.226 181.551 109.297 181.579 108.386C181.738 103.275 182.124 97.4204 182.283 92.3085C181.226 91.9593 178.749 91.8181 177.692 91.4689C177.138 97.1791 175.168 103.115 175.912 108.826C176.047 109.867 176.284 110.93 176.878 111.771C177.472 112.611 178.499 113.179 179.462 112.93Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.634 94.8781C176.986 97.4758 176.337 100.082 176.01 102.747C175.683 105.411 175.687 108.152 176.335 110.75C176.083 105.429 176.521 100.073 177.634 94.8781Z",
    fill: "#E7EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.175 93.9887C180.587 93.9887 179.026 93.6967 177.534 93.12C177.485 93.101 177.46 93.0438 177.478 92.9918C177.496 92.9398 177.55 92.9134 177.598 92.932C179.07 93.5008 180.609 93.789 182.175 93.789C182.198 93.789 182.227 93.7872 182.243 93.789C182.295 93.789 182.337 93.8331 182.338 93.8886C182.338 93.9436 182.296 93.9887 182.244 93.9891C182.221 93.9887 182.198 93.9887 182.175 93.9887Z",
    fill: "url(#paint57_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.701 130.174C189.124 130.246 189.544 130.31 189.947 130.34C188.495 122.652 187.088 110.429 188.306 102.696C188.589 100.897 188.65 98.2752 187.609 96.8238C187.044 96.0362 185.799 94.3227 184.944 93.9284C184.081 93.5311 182.869 93.1568 182.023 92.8787C182.756 94.084 183.641 95.6086 183.817 96.9131C185.243 105.237 185.232 118.324 186.202 127.401C186.354 128.817 187.375 129.951 188.701 130.174Z",
    fill: "#E9F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.295 129.216C187.246 129.216 187.206 129.177 187.201 129.125C186.604 122.717 186.316 111.795 186.83 105.636L185.533 105.86C185.488 105.868 185.448 105.842 185.431 105.799C185.415 105.755 185.428 105.706 185.464 105.679L187.057 104.497C186.293 100.638 184.966 96.9487 183.113 93.5312C183.087 93.4836 183.103 93.4221 183.148 93.3948C183.193 93.3675 183.251 93.3839 183.277 93.4316C185.151 96.8868 186.489 100.617 187.255 104.521C187.263 104.56 187.248 104.6 187.217 104.623L185.911 105.592L186.92 105.418C186.95 105.412 186.978 105.422 187 105.443C187.021 105.465 187.032 105.495 187.029 105.526C186.501 111.649 186.789 122.662 187.389 129.106C187.394 129.161 187.356 129.21 187.304 129.215C187.301 129.215 187.297 129.216 187.295 129.216Z",
    fill: "url(#paint58_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.596 129.988C188.692 129.988 187.801 129.682 187.068 129.118C187.026 129.085 187.016 129.023 187.047 128.978C187.078 128.933 187.137 128.924 187.179 128.956C187.926 129.531 188.843 129.825 189.768 129.784C189.824 129.787 189.864 129.825 189.866 129.88C189.868 129.935 189.827 129.981 189.775 129.984C189.715 129.987 189.655 129.988 189.596 129.988Z",
    fill: "url(#paint59_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.456 122.288C188.434 122.288 188.413 122.28 188.396 122.265L187.542 121.525C187.502 121.49 187.495 121.427 187.529 121.384C187.562 121.341 187.621 121.336 187.661 121.37L188.515 122.11C188.555 122.145 188.561 122.208 188.528 122.251C188.51 122.275 188.482 122.288 188.456 122.288Z",
    fill: "url(#paint60_linear_491_10957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.749 86.1776C173.055 86.2686 173.337 86.4467 173.558 86.6875C173.588 86.7205 173.619 86.7577 173.626 86.8032C173.64 86.892 173.564 86.9644 173.524 87.0441C173.449 87.1953 173.528 87.4085 173.68 87.4648C173.759 87.4943 173.874 87.5155 173.87 87.6039C173.868 87.6537 173.824 87.6875 173.789 87.7213C173.684 87.8257 173.645 87.9994 173.695 88.1433C173.524 88.0263 173.349 87.905 173.236 87.7265C173.122 87.548 173.085 87.2963 173.203 87.1204C173.219 87.0961 173.239 87.064 173.223 87.0393C173.211 87.022 173.188 87.0198 173.169 87.0181C172.992 87.0025 172.826 86.886 172.742 86.7196C172.66 86.5528 172.662 86.3418 172.749 86.1776Z",
    fill: "#D88568"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_10957",
    x1: 160.681,
    y1: 146.37,
    x2: 149.45,
    y2: 148.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_491_10957",
    x1: 299.899,
    y1: 62.5173,
    x2: 204.57,
    y2: 139.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_491_10957",
    x1: 227.944,
    y1: 68.9229,
    x2: 208.781,
    y2: 86.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_491_10957",
    x1: 248.935,
    y1: 68.9229,
    x2: 229.772,
    y2: 86.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_491_10957",
    x1: 246.632,
    y1: 68.9229,
    x2: 241.963,
    y2: 77.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_491_10957",
    x1: 269.927,
    y1: 68.9229,
    x2: 250.764,
    y2: 86.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_491_10957",
    x1: 222.003,
    y1: 93.5439,
    x2: 221.939,
    y2: 94.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_491_10957",
    x1: 222.003,
    y1: 95.3536,
    x2: 221.939,
    y2: 96.2364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_491_10957",
    x1: 243.193,
    y1: 93.5439,
    x2: 243.129,
    y2: 94.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_491_10957",
    x1: 243.193,
    y1: 95.3536,
    x2: 243.129,
    y2: 96.2364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_491_10957",
    x1: 264.383,
    y1: 93.5439,
    x2: 264.319,
    y2: 94.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_491_10957",
    x1: 264.383,
    y1: 95.3536,
    x2: 264.319,
    y2: 96.2364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_491_10957",
    x1: 131.342,
    y1: 72.4526,
    x2: 117.852,
    y2: 84.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_491_10957",
    x1: 127.592,
    y1: 76.4307,
    x2: 122.205,
    y2: 81.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_491_10957",
    x1: 145.182,
    y1: 72.4526,
    x2: 131.693,
    y2: 84.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_491_10957",
    x1: 141.432,
    y1: 76.4307,
    x2: 136.045,
    y2: 81.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_491_10957",
    x1: 160.702,
    y1: 79.4922,
    x2: 143.893,
    y2: 111.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_491_10957",
    x1: 152.997,
    y1: 44.101,
    x2: 149.259,
    y2: 45.6604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_491_10957",
    x1: 174.435,
    y1: 43.0178,
    x2: 172.684,
    y2: 45.1669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_491_10957",
    x1: 96.605,
    y1: 49.4456,
    x2: 83.4896,
    y2: 62.6127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_491_10957",
    x1: 104.563,
    y1: 50.6003,
    x2: 87.2909,
    y2: 59.5114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_491_10957",
    x1: 102.705,
    y1: 62.3826,
    x2: 82.9437,
    y2: 74.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_491_10957",
    x1: 74.6212,
    y1: 53.7891,
    x2: 64.7687,
    y2: 55.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_491_10957",
    x1: 84.8105,
    y1: 94.0358,
    x2: 75.6189,
    y2: 102.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_491_10957",
    x1: 82.4162,
    y1: 81.386,
    x2: 80.6474,
    y2: 82.2282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_491_10957",
    x1: 71.9351,
    y1: 169.584,
    x2: 68.2675,
    y2: 176.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_491_10957",
    x1: 81.5164,
    y1: 126.951,
    x2: 61.4417,
    y2: 130.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_491_10957",
    x1: 81.3738,
    y1: 173.884,
    x2: 79.2862,
    y2: 178.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_491_10957",
    x1: 86.2432,
    y1: 126.31,
    x2: 65.7952,
    y2: 129.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_491_10957",
    x1: 85.1074,
    y1: 94.4098,
    x2: 59.2853,
    y2: 105.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_491_10957",
    x1: 85.3727,
    y1: 95.5811,
    x2: 67.5968,
    y2: 112.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_491_10957",
    x1: 263.169,
    y1: 130.883,
    x2: 233.655,
    y2: 162.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_491_10957",
    x1: 267.949,
    y1: 134.086,
    x2: 228.202,
    y2: 159.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_491_10957",
    x1: 255.236,
    y1: 140.053,
    x2: 238.585,
    y2: 150.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_491_10957",
    x1: 257.831,
    y1: 104.07,
    x2: 243.309,
    y2: 117.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_491_10957",
    x1: 256.047,
    y1: 105.635,
    x2: 245.557,
    y2: 112.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_491_10957",
    x1: 138.92,
    y1: 90.2391,
    x2: 123.129,
    y2: 102.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_491_10957",
    x1: 122.959,
    y1: 136.611,
    x2: 118.687,
    y2: 136.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_491_10957",
    x1: 131.238,
    y1: 100.939,
    x2: 121.831,
    y2: 110.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_491_10957",
    x1: 138.69,
    y1: 102.786,
    x2: 92.2272,
    y2: 121.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_491_10957",
    x1: 146.044,
    y1: 107.884,
    x2: 130.317,
    y2: 112.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_491_10957",
    x1: 147.539,
    y1: 107.424,
    x2: 121.04,
    y2: 120.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_491_10957",
    x1: 199.131,
    y1: 120.735,
    x2: 165.262,
    y2: 126.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_491_10957",
    x1: 185.829,
    y1: 120.735,
    x2: 157.158,
    y2: 124.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_491_10957",
    x1: 183.748,
    y1: 123.307,
    x2: 182.12,
    y2: 125.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_491_10957",
    x1: 178.467,
    y1: 94.6229,
    x2: 172.719,
    y2: 96.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_491_10957",
    x1: 180.514,
    y1: 86.7092,
    x2: 172.149,
    y2: 91.7249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_491_10957",
    x1: 181.774,
    y1: 76.9684,
    x2: 166.141,
    y2: 84.6845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_491_10957",
    x1: 190.494,
    y1: 92.9818,
    x2: 177.115,
    y2: 94.6731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_491_10957",
    x1: 185.051,
    y1: 99.4225,
    x2: 180.693,
    y2: 99.6487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_491_10957",
    x1: 185.802,
    y1: 96.226,
    x2: 178.505,
    y2: 96.9109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_491_10957",
    x1: 181.787,
    y1: 97.2771,
    x2: 158.766,
    y2: 105.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_491_10957",
    x1: 180.391,
    y1: 92.0176,
    x2: 164.616,
    y2: 93.8719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_491_10957",
    x1: 180.602,
    y1: 129.214,
    x2: 176.174,
    y2: 137.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_491_10957",
    x1: 177.627,
    y1: 120.083,
    x2: 170.845,
    y2: 125.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_491_10957",
    x1: 190.453,
    y1: 99.8912,
    x2: 181.489,
    y2: 100.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_491_10957",
    x1: 177.772,
    y1: 101.547,
    x2: 172.448,
    y2: 102.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_491_10957",
    x1: 183.557,
    y1: 92.926,
    x2: 182.266,
    y2: 96.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_491_10957",
    x1: 188.464,
    y1: 93.3816,
    x2: 179.827,
    y2: 93.9628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_491_10957",
    x1: 190.577,
    y1: 128.937,
    x2: 188.84,
    y2: 131.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_491_10957",
    x1: 188.811,
    y1: 121.348,
    x2: 187.292,
    y2: 122.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_10957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306,
    height: 178,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminillustration1);
export default __webpack_public_path__ + "static/media/admin illustration 1.305b5b5e2d2fe5e0ac08364e6be62cae.svg";
export { ForwardRef as ReactComponent };